var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginLeftCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-secure-login",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    svg#freepik_stories-secure-login:not(.animated) .animable {opacity: 0;}svg#freepik_stories-secure-login.animated #freepik--speech-bubble--inject-81 {animation: 6s Infinite  linear floating;animation-delay: 0s;}            @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-81",
    className: "animable",
    style: {
      transformOrigin: "251.125px 182.165px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.35,
    y: 34.51,
    width: 377.59,
    height: 295.35,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "224.145px 182.185px"
    },
    id: "el9jojx5lgbnk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.94,329.86c0-1.79-.09-117.11-.22-295.35l.22.21-377.56.05h0l.26-.26c0,106.5,0,207.21,0,295.35l-.23-.23,377.59.23-377.59.23h-.23v-.24c0-88.14,0-188.85,0-295.35v-.26h.29l377.56,0h.21v.22C413,212.75,412.94,328.07,412.94,329.86Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "224.21px 182.165px"
    },
    id: "el6rsrum53h23",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4,106.82H68.13A2.79,2.79,0,0,1,65.35,104V73.22a2.79,2.79,0,0,1,2.78-2.79H82.25L93.18,81.7V104A2.79,2.79,0,0,1,90.4,106.82Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "79.265px 88.625px"
    },
    id: "elo0pmzp81iu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.25,70.43v8.68a2.59,2.59,0,0,0,2.59,2.59h8.34Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "87.715px 76.065px"
    },
    id: "el50ngk2grj4i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.37,79.87a2.87,2.87,0,0,0,2.28,2.79,1.31,1.31,0,0,0,.27.06c1.09.2,8.26,1.47,8.26,1.31V81.7H84.84S82.76,81.63,82.37,79.87Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "87.775px 81.957px"
    },
    id: "eldxhzcvav7nw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4,106.82s.16,0,.48-.06a2.82,2.82,0,0,0,1.26-.59,2.76,2.76,0,0,0,1-2c0-.9,0-1.94,0-3.11,0-4.66,0-11.34,0-19.4l0,0L82.18,70.5l.07,0H68.76a7.54,7.54,0,0,0-1.07,0A2.67,2.67,0,0,0,66,71.66,2.62,2.62,0,0,0,65.46,73c0,.49,0,1,0,1.51v3c0,2,0,3.95,0,5.88V94.53c0,1.77,0,3.49,0,5.17v3.69a6.43,6.43,0,0,0,0,1.17,2.7,2.7,0,0,0,2.29,2.15,7.9,7.9,0,0,0,1.09,0h4.2l12.69,0,3.44,0h0l-3.44,0-12.69,0h-4.2a10.37,10.37,0,0,1-1.11,0,2.7,2.7,0,0,1-1.09-.39,2.86,2.86,0,0,1-1.34-1.89,6,6,0,0,1,0-1.2V94.53c0-3.54,0-7.26,0-11.11V74.54c0-.51,0-1,0-1.53a2.82,2.82,0,0,1,.53-1.47,2.92,2.92,0,0,1,1.87-1.16,5.85,5.85,0,0,1,1.1,0H82.29l0,0L93.24,81.64l0,0v0c0,8.06,0,14.74,0,19.4,0,1.17,0,2.2,0,3.11a2.82,2.82,0,0,1-1,2,2.91,2.91,0,0,1-1.29.58l-.36,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "79.255px 88.587px"
    },
    id: "elj1oxut9rmi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.18,81.7l-.21,0-.62,0-2.26,0-3.35,0h-2a2.72,2.72,0,0,1-1.94-.91,2.81,2.81,0,0,1-.54-1,3,3,0,0,1-.12-1.06v-2c0-1.25,0-2.39,0-3.35s0-1.7,0-2.26c0-.25,0-.45,0-.61s0-.22,0-.22a.57.57,0,0,1,0,.22c0,.16,0,.36,0,.61,0,.56,0,1.33,0,2.26s0,2.1,0,3.35c0,.63,0,1.29,0,2a2.56,2.56,0,0,0,.62,1.9,2.52,2.52,0,0,0,1.8.85h2l3.35,0,2.26,0,.62,0C93.11,81.68,93.18,81.69,93.18,81.7Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "87.6553px 75.995px"
    },
    id: "elndf50j44q5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.83,78.17c0,.06-2.63.1-5.87.1s-5.87,0-5.87-.1,2.62-.1,5.87-.1S81.83,78.12,81.83,78.17Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "75.96px 78.17px"
    },
    id: "el62u91wqqmat",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4,82.5s-3.87.1-8.65.1-8.66,0-8.66-.1,3.87-.1,8.66-.1S87.4,82.44,87.4,82.5Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "78.745px 82.5px"
    },
    id: "elyz6s61po0a8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4,86.82c0,.06-3.87.1-8.65.1s-8.66,0-8.66-.1,3.87-.09,8.66-.09S87.4,86.77,87.4,86.82Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "78.745px 86.8249px"
    },
    id: "elwccqwnof6ud",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4,91.15s-3.87.1-8.65.1-8.66,0-8.66-.1,3.87-.1,8.66-.1S87.4,91.1,87.4,91.15Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "78.745px 91.15px"
    },
    id: "el8w7uqymjl5m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4,95.48s-3.87.09-8.65.09-8.66,0-8.66-.09,3.87-.1,8.66-.1S87.4,95.42,87.4,95.48Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "78.745px 95.475px"
    },
    id: "elnwkehkmgr7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4,100.81c0,.06-3.87.1-8.65.1s-8.66,0-8.66-.1,3.87-.1,8.66-.1S87.4,100.76,87.4,100.81Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "78.745px 100.81px"
    },
    id: "eljpz9952d5a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.05,116.05c0,.15-6.18.26-13.79.26s-13.8-.11-13.8-.26,6.18-.26,13.8-.26S93.05,115.91,93.05,116.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "79.255px 116.05px"
    },
    id: "elqfa809mnld",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.13,119.66a74.21,74.21,0,0,1-8.87.26,74.32,74.32,0,0,1-8.88-.26,76.93,76.93,0,0,1,8.88-.26A76.82,76.82,0,0,1,88.13,119.66Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "79.255px 119.662px"
    },
    id: "elehfzatdbeun",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4,185.59H68.13a2.79,2.79,0,0,1-2.78-2.79V152a2.79,2.79,0,0,1,2.78-2.79H82.25l10.93,11.27V182.8A2.79,2.79,0,0,1,90.4,185.59Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "79.265px 167.4px"
    },
    id: "el3vrvjkk2m8m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.25,149.2v8.68a2.59,2.59,0,0,0,2.59,2.59h8.34Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "87.715px 154.835px"
    },
    id: "el5ruv4w631gx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.37,158.64a2.87,2.87,0,0,0,2.28,2.79l.27.06c1.09.2,8.26,1.47,8.26,1.31v-2.33H84.84S82.76,160.4,82.37,158.64Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "87.775px 160.727px"
    },
    id: "elgflv10vjelc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4,185.59s.16,0,.48-.06a2.82,2.82,0,0,0,1.26-.59,2.76,2.76,0,0,0,1-2c0-.9,0-1.94,0-3.11,0-4.66,0-11.34,0-19.4l0,.05L82.18,149.27l.07,0H68.76a7.54,7.54,0,0,0-1.07,0A2.67,2.67,0,0,0,66,150.43a2.62,2.62,0,0,0-.49,1.37c0,.49,0,1,0,1.51v3c0,2,0,3.95,0,5.88V173.3c0,1.77,0,3.49,0,5.17v3.69a6.43,6.43,0,0,0,0,1.17,2.7,2.7,0,0,0,2.29,2.15,7.9,7.9,0,0,0,1.09,0h4.2l12.69,0,3.44,0h0l-3.44,0-12.69,0h-4.2a10.37,10.37,0,0,1-1.11,0,2.7,2.7,0,0,1-1.09-.39,2.86,2.86,0,0,1-1.34-1.89,6,6,0,0,1,0-1.2V173.3c0-3.54,0-7.26,0-11.11v-8.88c0-.51,0-1,0-1.53a2.82,2.82,0,0,1,.53-1.47,2.92,2.92,0,0,1,1.87-1.16,5.85,5.85,0,0,1,1.1,0H82.29l0,0,10.92,11.27,0,0v0c0,8.06,0,14.74,0,19.4,0,1.17,0,2.2,0,3.11a2.82,2.82,0,0,1-1,2,2.91,2.91,0,0,1-1.29.58l-.36,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "79.265px 167.357px"
    },
    id: "elsueb766xyc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.18,160.47l-.21,0-.62,0-2.26,0-3.35,0h-2a2.72,2.72,0,0,1-1.94-.91,2.81,2.81,0,0,1-.54-1,3,3,0,0,1-.12-1.06v-2c0-1.25,0-2.39,0-3.35s0-1.7,0-2.26c0-.25,0-.45,0-.61s0-.22,0-.22a.57.57,0,0,1,0,.22c0,.16,0,.36,0,.61,0,.56,0,1.33,0,2.26s0,2.1,0,3.35c0,.63,0,1.29,0,2a2.56,2.56,0,0,0,.62,1.9,2.52,2.52,0,0,0,1.8.85h2l3.35,0,2.26,0,.62,0C93.11,160.45,93.18,160.46,93.18,160.47Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "87.6553px 154.765px"
    },
    id: "eljpk2ekczg1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.83,156.94c0,.06-2.63.1-5.87.1s-5.87,0-5.87-.1,2.62-.1,5.87-.1S81.83,156.89,81.83,156.94Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "75.96px 156.94px"
    },
    id: "el5jpzppp7kg7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4,161.27s-3.87.1-8.65.1-8.66-.05-8.66-.1,3.87-.1,8.66-.1S87.4,161.21,87.4,161.27Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "78.745px 161.27px"
    },
    id: "el8fu8rmam8s4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4,165.59c0,.06-3.87.1-8.65.1s-8.66,0-8.66-.1,3.87-.09,8.66-.09S87.4,165.54,87.4,165.59Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "78.745px 165.595px"
    },
    id: "el7eixrpg84u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4,169.92c0,.05-3.87.1-8.65.1s-8.66-.05-8.66-.1,3.87-.1,8.66-.1S87.4,169.87,87.4,169.92Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "78.745px 169.92px"
    },
    id: "elexmwj2gzwr4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4,174.25c0,.05-3.87.09-8.65.09s-8.66,0-8.66-.09,3.87-.1,8.66-.1S87.4,174.19,87.4,174.25Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "78.745px 174.245px"
    },
    id: "elzqlz0uhdkha",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4,179.58c0,.06-3.87.1-8.65.1s-8.66,0-8.66-.1,3.87-.1,8.66-.1S87.4,179.53,87.4,179.58Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "78.745px 179.58px"
    },
    id: "elc350kio5qa6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.05,194.82c0,.15-6.18.26-13.79.26s-13.8-.11-13.8-.26,6.18-.26,13.8-.26S93.05,194.68,93.05,194.82Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "79.255px 194.82px"
    },
    id: "ell10gmv8yqg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.13,198.43a74.21,74.21,0,0,1-8.87.26,74.32,74.32,0,0,1-8.88-.26,76.93,76.93,0,0,1,8.88-.26A76.82,76.82,0,0,1,88.13,198.43Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "79.255px 198.432px"
    },
    id: "eltyow91bwv2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.87,282.22H66.6a2.79,2.79,0,0,1-2.78-2.79V248.62a2.79,2.79,0,0,1,2.78-2.79H80.72L91.65,257.1v22.33A2.79,2.79,0,0,1,88.87,282.22Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "77.735px 264.025px"
    },
    id: "elpcom2jdrv8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.72,245.83v8.67a2.59,2.59,0,0,0,2.59,2.59h8.34Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "86.185px 251.46px"
    },
    id: "elcsu1j5l9ke",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.84,255.26a2.88,2.88,0,0,0,2.28,2.8,2.3,2.3,0,0,0,.28.06c1.08.2,8.25,1.47,8.25,1.31V257.1H83.31S81.23,257,80.84,255.26Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "86.245px 257.352px"
    },
    id: "elizi4lt1l09",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.87,282.22s.16,0,.48-.06a2.82,2.82,0,0,0,1.26-.59,2.76,2.76,0,0,0,1-2c0-.9,0-1.95,0-3.11,0-4.66,0-11.34,0-19.4l0,0L80.65,245.9l.07,0H67.23a6.35,6.35,0,0,0-1.07,0,2.67,2.67,0,0,0-1.74,1.09,2.62,2.62,0,0,0-.49,1.37c0,.49,0,1,0,1.51v3c0,2,0,3.95,0,5.88v11.11c0,1.77,0,3.49,0,5.17v3.69A7.48,7.48,0,0,0,64,280a2.7,2.7,0,0,0,2.29,2.15,9.85,9.85,0,0,0,1.09,0h4.21l12.68,0,3.44,0H84.22l-12.68,0H67.33a8.32,8.32,0,0,1-1.11,0A2.87,2.87,0,0,1,63.79,280a6.06,6.06,0,0,1,0-1.2c0-.4,0-.81,0-1.21v-7.65c0-3.54,0-7.26,0-11.11v-8.88c0-.51,0-1,0-1.53a2.87,2.87,0,0,1,2.4-2.63,6.86,6.86,0,0,1,1.1-.05H80.76l0,0L91.71,257l0,0v0c0,8.06,0,14.74,0,19.4,0,1.17,0,2.2,0,3.11a2.82,2.82,0,0,1-1,2,2.72,2.72,0,0,1-1.29.57,2,2,0,0,1-.36,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "77.7351px 263.978px"
    },
    id: "eliudqr0317y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.65,257.1l-.21,0h-.62l-2.26,0-3.35,0h-2a2.68,2.68,0,0,1-1.93-.91,2.77,2.77,0,0,1-.55-1,3,3,0,0,1-.12-1.06v-2c0-1.26,0-2.39,0-3.35s0-1.7,0-2.26c0-.25,0-.45,0-.61s0-.22,0-.22a.57.57,0,0,1,0,.22l0,.61c0,.56,0,1.33,0,2.26s0,2.09,0,3.35c0,.63,0,1.29,0,2a2.58,2.58,0,0,0,.62,1.9,2.47,2.47,0,0,0,1.8.84h2l3.35,0,2.26,0,.62,0C91.58,257.08,91.65,257.09,91.65,257.1Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "86.1256px 251.395px"
    },
    id: "elf2sn9d3pw1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3,253.57c0,.05-2.63.1-5.87.1s-5.87,0-5.87-.1,2.63-.1,5.87-.1S80.3,253.52,80.3,253.57Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "74.43px 253.57px"
    },
    id: "elmrk0hx3jiwr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.87,257.9c0,.05-3.87.09-8.65.09s-8.66,0-8.66-.09,3.87-.1,8.66-.1S85.87,257.84,85.87,257.9Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "77.215px 257.895px"
    },
    id: "el09zugb5r7nis",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.87,262.22c0,.06-3.87.1-8.65.1s-8.66,0-8.66-.1,3.87-.1,8.66-.1S85.87,262.17,85.87,262.22Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "77.215px 262.22px"
    },
    id: "elpmm5doz60zl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.87,266.55c0,.05-3.87.1-8.65.1s-8.66,0-8.66-.1,3.87-.1,8.66-.1S85.87,266.49,85.87,266.55Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "77.215px 266.55px"
    },
    id: "el219bvae9f57",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.87,270.87c0,.06-3.87.1-8.65.1s-8.66,0-8.66-.1,3.87-.09,8.66-.09S85.87,270.82,85.87,270.87Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "77.215px 270.875px"
    },
    id: "elmar6f7wsqt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.87,276.21c0,.05-3.87.1-8.65.1s-8.66-.05-8.66-.1,3.87-.1,8.66-.1S85.87,276.16,85.87,276.21Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "77.215px 276.21px"
    },
    id: "elvzwvypdpce",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.52,291.45c0,.14-6.18.26-13.79.26s-13.79-.12-13.79-.26,6.17-.26,13.79-.26S91.52,291.31,91.52,291.45Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "77.73px 291.45px"
    },
    id: "elbq6v41m0ru6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.61,295.06a77.07,77.07,0,0,1-8.88.26,76.93,76.93,0,0,1-8.88-.26,76.93,76.93,0,0,1,8.88-.26A77.07,77.07,0,0,1,86.61,295.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "77.73px 295.06px"
    },
    id: "elh2a2kemplaq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.28,280H213a2.77,2.77,0,0,1-2.78-2.78V246.42a2.78,2.78,0,0,1,2.78-2.79h14.12l10.93,11.26v22.34A2.78,2.78,0,0,1,235.28,280Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "224.135px 261.815px"
    },
    id: "el5vl3ymt6n8a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.14,243.63v8.67a2.59,2.59,0,0,0,2.59,2.59h8.34Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "232.605px 249.26px"
    },
    id: "elyvdf2l5qlwi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.25,253.06a2.88,2.88,0,0,0,2.29,2.8l.27.06c1.09.19,8.26,1.47,8.26,1.3v-2.33h-8.34S227.65,254.82,227.25,253.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "232.66px 255.148px"
    },
    id: "elcarn7eua9vj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.28,280a3.37,3.37,0,0,0,.48-.05,2.8,2.8,0,0,0,1.27-.59,2.75,2.75,0,0,0,1-2c0-.89,0-1.94,0-3.1,0-4.67,0-11.34,0-19.41l0,.06L227.07,243.7l.07,0H213.65a6.31,6.31,0,0,0-1.07,0,2.67,2.67,0,0,0-1.74,1.09,2.63,2.63,0,0,0-.5,1.36c0,.5,0,1,0,1.52v20c0,1.77,0,3.49,0,5.17v3.69a6.43,6.43,0,0,0,.05,1.17,2.7,2.7,0,0,0,2.29,2.15c.35,0,.73,0,1.09,0H218l12.68,0h3.45l-3.45,0-12.68,0h-4.2a10.42,10.42,0,0,1-1.11,0,2.84,2.84,0,0,1-1.09-.38,2.88,2.88,0,0,1-1.34-1.89,6.94,6.94,0,0,1-.06-1.2v-8.86c0-3.54,0-7.26,0-11.11v-8.88c0-.51,0-1,0-1.53a2.82,2.82,0,0,1,.53-1.47,2.89,2.89,0,0,1,1.87-1.17,8.21,8.21,0,0,1,1.1,0h13.53l0,0,10.92,11.28,0,0v0c0,8.07,0,14.74,0,19.41,0,1.17,0,2.2,0,3.11a2.84,2.84,0,0,1-1,2,2.8,2.8,0,0,1-1.29.57,1.28,1.28,0,0,1-.36,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "224.173px 261.671px"
    },
    id: "elrr2ncwoh3vf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.07,254.89s-.07,0-.21,0l-.62,0L235,255l-3.35,0h-2a2.66,2.66,0,0,1-2.48-1.88,3.28,3.28,0,0,1-.13-1.06c0-.69,0-1.35,0-2,0-1.26,0-2.39,0-3.35s0-1.7,0-2.26c0-.25,0-.45,0-.62a.85.85,0,0,1,0-.21.85.85,0,0,1,0,.21l0,.62c0,.56,0,1.32,0,2.26s0,2.09,0,3.35c0,.63,0,1.29,0,2a2.58,2.58,0,0,0,.62,1.9,2.47,2.47,0,0,0,1.8.84h2l3.35,0,2.26,0h.62Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "232.551px 249.31px"
    },
    id: "elfddqdfz9195",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.72,251.37s-2.63.1-5.87.1-5.88-.05-5.88-.1,2.63-.1,5.88-.1S226.72,251.31,226.72,251.37Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "220.845px 251.37px"
    },
    id: "el2spwnfsrxu4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.29,255.69c0,.06-3.87.1-8.66.1s-8.66,0-8.66-.1,3.88-.09,8.66-.09S232.29,255.64,232.29,255.69Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "223.63px 255.695px"
    },
    id: "elb99322mflv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.29,260c0,.06-3.87.1-8.66.1s-8.66,0-8.66-.1,3.88-.1,8.66-.1S232.29,260,232.29,260Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "223.63px 260px"
    },
    id: "el3n9ekffyjo9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.29,264.35s-3.87.09-8.66.09-8.66,0-8.66-.09,3.88-.1,8.66-.1S232.29,264.29,232.29,264.35Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "223.63px 264.345px"
    },
    id: "elbue63uy2fzj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.29,268.67c0,.06-3.87.1-8.66.1s-8.66,0-8.66-.1,3.88-.1,8.66-.1S232.29,268.62,232.29,268.67Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "223.63px 268.67px"
    },
    id: "elqbrlz1vg1v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.29,274c0,.05-3.87.1-8.66.1s-8.66-.05-8.66-.1,3.88-.1,8.66-.1S232.29,274,232.29,274Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "223.63px 274px"
    },
    id: "el7dx46wj7fq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.94,289.25c0,.14-6.18.26-13.8.26s-13.79-.12-13.79-.26,6.18-.26,13.79-.26S237.94,289.1,237.94,289.25Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "224.145px 289.25px"
    },
    id: "elfphsyv0ycm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,292.86a76.93,76.93,0,0,1-8.88.26,76.82,76.82,0,0,1-8.87-.26,76.82,76.82,0,0,1,8.87-.26A76.93,76.93,0,0,1,233,292.86Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "224.125px 292.86px"
    },
    id: "elocxk032laq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,56.83,148,76.75A1.26,1.26,0,0,0,149.16,78h30.72A1.26,1.26,0,0,0,181,76.67V61.16a1.26,1.26,0,0,0-1.16-1.35L161,60a1.09,1.09,0,0,1-.82-.39l-3.28-3.78a1.07,1.07,0,0,0-.81-.38h-8A1.27,1.27,0,0,0,147,56.83Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "163.999px 66.725px"
    },
    id: "elu2r3rht4ou",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.46,
    y: 57.46,
    width: 33.57,
    height: 23.41,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "164.245px 69.165px"
    },
    id: "elhkc1ug7sjx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.79,59.56,147.35,84a.81.81,0,0,0,.74.76h32.72a.8.8,0,0,0,.74-.8l1.65-24.42a.83.83,0,0,0-.74-.93H145.53A.83.83,0,0,0,144.79,59.56Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "163.994px 71.685px"
    },
    id: "el9met43pvvpn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.78,97.13c0,.15-6.17.26-13.79.26s-13.79-.11-13.79-.26,6.17-.26,13.79-.26S177.78,97,177.78,97.13Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "163.99px 97.13px"
    },
    id: "elk9mtwp9j19f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.87,100.74A74.32,74.32,0,0,1,164,101a74.45,74.45,0,0,1-8.88-.26,77.07,77.07,0,0,1,8.88-.26A76.93,76.93,0,0,1,172.87,100.74Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "163.995px 100.742px"
    },
    id: "elev82xx32anq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,150.48l1.05,19.92a1.25,1.25,0,0,0,1.16,1.26H181a1.25,1.25,0,0,0,1.15-1.34V154.8a1.25,1.25,0,0,0-1.16-1.34l-18.89.14a1.09,1.09,0,0,1-.82-.39L158,149.44a1.08,1.08,0,0,0-.81-.39h-8A1.28,1.28,0,0,0,148,150.48Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "165.072px 160.355px"
    },
    id: "elvltm5nxnz0c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.54,
    y: 151.1,
    width: 33.57,
    height: 23.41,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "165.325px 162.805px"
    },
    id: "elil1c2rsisz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.87,153.21l2.57,24.41a.78.78,0,0,0,.73.76h32.72a.79.79,0,0,0,.74-.79l1.65-24.42a.83.83,0,0,0-.74-.93H146.61A.83.83,0,0,0,145.87,153.21Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "165.072px 165.31px"
    },
    id: "elqhgrugdqyw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.86,190.78c0,.14-6.17.26-13.79.26s-13.79-.12-13.79-.26,6.17-.26,13.79-.26S178.86,190.63,178.86,190.78Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "165.07px 190.78px"
    },
    id: "el30r5lbv6lsf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,194.39a76.93,76.93,0,0,1-8.88.26,77.07,77.07,0,0,1-8.88-.26,74.45,74.45,0,0,1,8.88-.26A74.32,74.32,0,0,1,174,194.39Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "165.12px 194.388px"
    },
    id: "elj86m67w1dfd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.79,265.94l1.06,19.92a1.24,1.24,0,0,0,1.15,1.26h30.72a1.26,1.26,0,0,0,1.16-1.34V270.26a1.25,1.25,0,0,0-1.16-1.34l-18.9.14a1.09,1.09,0,0,1-.82-.39l-3.28-3.77a1.08,1.08,0,0,0-.81-.39h-8A1.28,1.28,0,0,0,131.79,265.94Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "148.832px 275.815px"
    },
    id: "elb8zibs0z4v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.3,
    y: 266.56,
    width: 33.57,
    height: 23.41,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "149.085px 278.265px"
    },
    id: "elpo2e4y5z9ud",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.63,268.66l2.57,24.42a.78.78,0,0,0,.73.76h32.72a.8.8,0,0,0,.74-.8L168,268.63a.83.83,0,0,0-.74-.94H130.37A.83.83,0,0,0,129.63,268.66Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "148.813px 280.765px"
    },
    id: "el9b9ql541s3q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.62,306.24c0,.14-6.17.26-13.79.26s-13.79-.12-13.79-.26,6.18-.26,13.79-.26S162.62,306.09,162.62,306.24Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "148.83px 306.24px"
    },
    id: "elj44zbbkmq5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.71,309.85a76.93,76.93,0,0,1-8.88.26,77.07,77.07,0,0,1-8.88-.26,74.45,74.45,0,0,1,8.88-.26A74.32,74.32,0,0,1,157.71,309.85Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "148.83px 309.848px"
    },
    id: "elphp8ahn053",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.23,
    y: 51.34,
    width: 222.2,
    height: 195.41,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "355.33px 149.045px"
    },
    id: "elo584h2pkxdm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.43,246.75c0-1.85-.09-77.83-.22-195.41l.22.22-222.18,0h0l.26-.26c0,71,0,137.89,0,195.41l-.23-.23,222.2.23-222.2.23H244v-.23c0-57.52,0-124.39,0-195.41v-.26h.28l222.18,0h.22v.22C466.52,168.92,466.43,244.9,466.43,246.75Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "355.34px 148.99px"
    },
    id: "elmh1pd6rg8ps",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.07,71.39c0,.09-49.33.17-110.17.17s-110.19-.08-110.19-.17,49.33-.18,110.19-.18S467.07,71.29,467.07,71.39Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "356.89px 71.385px"
    },
    id: "elfyeak0hc7w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.35,62.24A2.28,2.28,0,1,1,257.07,60,2.28,2.28,0,0,1,259.35,62.24Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "257.07px 62.28px"
    },
    id: "el44k2bpimq0k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.84,62.24A2.28,2.28,0,1,1,264.56,60,2.28,2.28,0,0,1,266.84,62.24Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "264.56px 62.28px"
    },
    id: "el79ma7f0knlt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.33,62.24A2.28,2.28,0,1,1,272.05,60,2.28,2.28,0,0,1,274.33,62.24Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "272.05px 62.28px"
    },
    id: "elpo1jp2kg8w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.09,88.63a2.5,2.5,0,0,0,.37-.07,1.28,1.28,0,0,0,.78-.73,1.86,1.86,0,0,0,.09-.8c0-.31,0-.64,0-1,0-.72,0-1.56,0-2.49s0-2,0-3.13c0-.29,0-.59,0-.87a1.19,1.19,0,0,0-1.15-1.08h-1l-9.07,0-52.54,0a1.1,1.1,0,0,0-1.11,1v7.53a1.44,1.44,0,0,0,.14.82,1.14,1.14,0,0,0,.6.5,1.34,1.34,0,0,0,.4.06h17.15l23.62,0,15.92.06,4.33,0,1.13,0h.38a2.79,2.79,0,0,1-.38,0l-1.13,0-4.33,0-15.92.06-23.62,0-13.95,0h-3.2a1.75,1.75,0,0,1-.51-.08,1.51,1.51,0,0,1-.79-.66,1.78,1.78,0,0,1-.19-1V79.52a1.47,1.47,0,0,1,1.46-1.34l52.54,0,9.07,0h1a1.36,1.36,0,0,1,1.32,1.25c0,.32,0,.6,0,.89,0,1.14,0,2.18,0,3.13s0,1.77,0,2.49c0,.37,0,.7,0,1a2,2,0,0,1-.11.83,1.29,1.29,0,0,1-.83.73A.9.9,0,0,1,456.09,88.63Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "424.803px 83.405px"
    },
    id: "elgnrj1h7g24v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.3,84.81l.17-.36a1.67,1.67,0,0,0,1.08.37c.57,0,.81-.22.81-.5,0-.8-2-.3-2-1.51,0-.51.39-.94,1.25-.94a2,2,0,0,1,1.05.29l-.15.38a1.65,1.65,0,0,0-.9-.27c-.56,0-.8.23-.8.52,0,.8,2,.3,2,1.5,0,.5-.4.93-1.27.93A2,2,0,0,1,396.3,84.81Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "397.555px 83.5451px"
    },
    id: "elo3dy03j66wh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.67,84.09h-2a.83.83,0,0,0,.9.73.91.91,0,0,0,.71-.3l.25.29a1.26,1.26,0,0,1-1,.4A1.24,1.24,0,0,1,399.21,84a1.22,1.22,0,0,1,1.24-1.27A1.2,1.2,0,0,1,401.68,84S401.67,84.05,401.67,84.09Zm-2-.32h1.59a.78.78,0,0,0-.8-.71A.76.76,0,0,0,399.66,83.77Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "400.446px 83.9711px"
    },
    id: "elymqyydcwdn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.2,83.69v1.5h-.43v-.33a.93.93,0,0,1-.81.35c-.57,0-.92-.3-.92-.73s.26-.72,1-.72h.71v-.09c0-.38-.22-.6-.67-.6a1.21,1.21,0,0,0-.78.27l-.19-.34a1.63,1.63,0,0,1,1-.32C403.81,82.68,404.2,83,404.2,83.69Zm-.45.74v-.35h-.7c-.44,0-.57.17-.57.38s.21.41.55.41A.74.74,0,0,0,403.75,84.43Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "403.12px 83.9466px"
    },
    id: "elnbq9yj3tih",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.36,82.68v.44h-.1a.74.74,0,0,0-.78.84v1.24H405V82.7h.43v.42A1,1,0,0,1,406.36,82.68Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "405.68px 83.9376px"
    },
    id: "elwprg1nfv149",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.66,84A1.25,1.25,0,0,1,408,82.68a1.09,1.09,0,0,1,1,.53l-.34.22a.78.78,0,0,0-.67-.36.88.88,0,0,0,0,1.75.76.76,0,0,0,.67-.36l.34.22a1.09,1.09,0,0,1-1,.53A1.24,1.24,0,0,1,406.66,84Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "407.829px 83.9453px"
    },
    id: "elqxh14ysc5m8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.89,83.76v1.43h-.45V83.81c0-.49-.25-.73-.67-.73a.74.74,0,0,0-.79.83v1.28h-.45V81.71H410v1.35a1.09,1.09,0,0,1,.88-.38A1,1,0,0,1,411.89,83.76Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "410.712px 83.45px"
    },
    id: "elglwr2ztk0mc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.51,84.89a.31.31,0,0,1,.32-.32.32.32,0,0,1,0,.64A.31.31,0,0,1,412.51,84.89Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "412.83px 84.89px"
    },
    id: "elm8qxytuo9v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.57,84.89a.32.32,0,0,1,.32-.32.32.32,0,0,1,0,.64A.32.32,0,0,1,413.57,84.89Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "413.89px 84.89px"
    },
    id: "elnyl5tpllzca",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.63,84.89a.32.32,0,0,1,.32-.32.32.32,0,0,1,0,.64A.32.32,0,0,1,414.63,84.89Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "414.95px 84.89px"
    },
    id: "elgxh1sydgvn6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.88,105.31v35h42.6v-35a3,3,0,0,0-3-3H384.91A3,3,0,0,0,381.88,105.31Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "403.18px 121.31px"
    },
    id: "elykyvv0zopw8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "383.88 121.32 384.17 108.45 421.44 108.45 421.44 115.79",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "402.66px 114.885px"
    },
    id: "eluf0iabaaz4s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.59,
    y: 104.97,
    width: 32.57,
    height: 3.48,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "402.875px 106.71px"
    },
    id: "el1a1dx9ascq7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.59,105h.63l1.85,0,6.88-.06,23.21-.07h.17V105c0,1.11,0,2.29,0,3.48-.35.35-.11.1-.19.18H408.77l-9.19,0-13-.07h-.07v-.07c0-1.12,0-2,0-2.61,0-.27,0-.49,0-.65a1.76,1.76,0,0,1,0-.22,1.35,1.35,0,0,1,0,.24c0,.17,0,.4,0,.68,0,.6,0,1.46,0,2.56l-.08-.07,13-.07,9.19,0h10.38c-.07.07.19-.18-.16.17V105l.17.18-23.08-.08-6.93,0-1.88,0h-.5Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "402.88px 106.771px"
    },
    id: "el21sq4zxbxha",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423,149.12c0,.1-8.14.18-18.18.18s-18.18-.08-18.18-.18,8.14-.17,18.18-.17S423,149,423,149.12Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "404.82px 149.125px"
    },
    id: "el4ovbuytmjhf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.61,115l3.27,25.36h42.6V115.79H405.14l-3.76-3.3H380.81A2.22,2.22,0,0,0,378.61,115Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "401.535px 126.425px"
    },
    id: "els2jkyhxlbrd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.76,125.72c0,.1-4.67.18-10.42.18s-10.42-.08-10.42-.18,4.67-.17,10.42-.17S412.76,125.63,412.76,125.72Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "402.34px 125.725px"
    },
    id: "elm32hqg8l2h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.76,128.22c0,.1-4.67.17-10.42.17s-10.42-.07-10.42-.17,4.67-.18,10.42-.18S412.76,128.12,412.76,128.22Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "402.34px 128.215px"
    },
    id: "elxba00gqhdvq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,153.86c0,.1-5.1.18-11.4.18s-11.4-.08-11.4-.18,5.11-.17,11.4-.17S414,153.77,414,153.86Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "402.6px 153.865px"
    },
    id: "ellxgtkw68k3e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.23,105.31v35h42.6v-35a3,3,0,0,0-3-3H292.26A3,3,0,0,0,289.23,105.31Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "310.53px 121.31px"
    },
    id: "elnckrxvgcg3s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "291.23 121.32 291.52 108.45 328.79 108.45 328.79 115.79",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "310.01px 114.885px"
    },
    id: "el4scgv3fofze",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.94,
    y: 104.97,
    width: 32.57,
    height: 3.48,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "310.225px 106.71px"
    },
    id: "elc4la699ebg8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.94,105h.63l1.85,0,6.88-.06,23.21-.07h.17V105c0,1.11,0,2.29,0,3.48-.35.35-.11.1-.19.18H316.12l-9.19,0-13-.07h-.07v-.07c0-1.12,0-2,0-2.61,0-.27,0-.49,0-.65a1.76,1.76,0,0,1,0-.22,1.35,1.35,0,0,1,0,.24c0,.17,0,.4,0,.68,0,.6,0,1.46,0,2.56l-.08-.07,13-.07,9.19,0H326.5c-.07.07.19-.18-.16.17V105l.17.18-23.08-.08-6.93,0-1.88,0h-.5Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "310.23px 106.771px"
    },
    id: "elv3vpt0k909",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.3,149.12c0,.1-8.14.18-18.18.18s-18.18-.08-18.18-.18,8.14-.17,18.18-.17S330.3,149,330.3,149.12Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "312.12px 149.125px"
    },
    id: "elj7a3gu96b9d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,115l3.27,25.36h42.6V115.79H312.49l-3.76-3.3H288.16A2.22,2.22,0,0,0,286,115Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "308.925px 126.425px"
    },
    id: "elya2jso7c7dk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.11,125.72c0,.1-4.67.18-10.42.18s-10.42-.08-10.42-.18,4.67-.17,10.42-.17S320.11,125.63,320.11,125.72Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "309.69px 125.725px"
    },
    id: "el6fejrsz7jpy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.11,128.22c0,.1-4.67.17-10.42.17s-10.42-.07-10.42-.17,4.67-.18,10.42-.18S320.11,128.12,320.11,128.22Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "309.69px 128.215px"
    },
    id: "elktubybbhejn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.37,153.86c0,.1-5.1.18-11.4.18s-11.4-.08-11.4-.18,5.11-.17,11.4-.17S321.37,153.77,321.37,153.86Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "309.97px 153.865px"
    },
    id: "el0adf9x5obio",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.9,179.75v35h42.59v-35a3,3,0,0,0-3-3H290.92A3,3,0,0,0,287.9,179.75Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "309.195px 195.75px"
    },
    id: "elurrrl5iiqai",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "289.9 195.76 290.18 182.89 327.45 182.89 327.45 190.23",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "308.675px 189.325px"
    },
    id: "eljd4ce5y736k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.6,
    y: 179.41,
    width: 32.57,
    height: 3.48,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "308.885px 181.15px"
    },
    id: "el16zpgyaxoc8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.6,179.42l.16,0h.47l1.85,0,6.88-.05,23.21-.08h.18v3.65c-.35.35-.11.1-.19.18H314.78l-9.19,0-13-.07h-.08v-.08c0-1.12,0-2,0-2.61,0-.27,0-.48,0-.65s0-.22,0-.21a1,1,0,0,1,0,.23c0,.18,0,.4,0,.68,0,.6,0,1.46,0,2.56l-.07-.07,13-.07,9.19,0h10.38c-.07.08.19-.17-.16.17v-3.47l.17.17-23.08-.08-6.93,0-1.88,0h-.68Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "308.895px 181.211px"
    },
    id: "ellg4v4muvd99",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,223.56c0,.1-8.14.18-18.18.18s-18.18-.08-18.18-.18,8.14-.17,18.18-.17S329,223.47,329,223.56Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "310.82px 223.565px"
    },
    id: "el8i4h99yem5f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.62,189.43l3.28,25.36h42.59V190.23H311.15l-3.75-3.3H286.82A2.22,2.22,0,0,0,284.62,189.43Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "307.546px 200.86px"
    },
    id: "el9cphhgnk6zf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.77,200.17c0,.09-4.66.17-10.42.17s-10.42-.08-10.42-.17,4.67-.18,10.42-.18S318.77,200.07,318.77,200.17Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "308.35px 200.165px"
    },
    id: "el5696f4bhfsx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.77,202.66c0,.1-4.66.17-10.42.17s-10.42-.07-10.42-.17,4.67-.17,10.42-.17S318.77,202.56,318.77,202.66Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "308.35px 202.66px"
    },
    id: "eldavtcb0lo36",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,228.3c0,.1-5.1.18-11.4.18s-11.4-.08-11.4-.18,5.11-.17,11.4-.17S320,228.21,320,228.3Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "308.6px 228.305px"
    },
    id: "el1wrnfe8tbfb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.56,179.75v35h42.6v-35a3,3,0,0,0-3-3H384.58A3,3,0,0,0,381.56,179.75Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "402.86px 195.75px"
    },
    id: "el0zyjkzv3d1c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "383.56 195.76 383.84 182.89 421.12 182.89 421.12 190.23",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "402.34px 189.325px"
    },
    id: "elfrbptak854a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.27,
    y: 179.41,
    width: 32.57,
    height: 3.48,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "402.555px 181.15px"
    },
    id: "elb4zbhgd6etu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.27,179.42s.05,0,.15,0h.47l1.85,0,6.89-.05,23.21-.08H419v3.65l-.18.18H408.45l-9.19,0-13-.07h-.08v-.08c0-1.12,0-2,.05-2.61,0-.27,0-.48,0-.65s0-.22,0-.21a2.07,2.07,0,0,1,0,.23c0,.18,0,.4,0,.68,0,.6,0,1.46,0,2.56l-.07-.07,13-.07,9.19,0h10.38c-.08.08.18-.17-.17.17v-3.47l.18.17-23.09-.08-6.92,0-1.89,0h-.67Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "402.58px 181.205px"
    },
    id: "el279efixg5qn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.63,223.56c0,.1-8.14.18-18.18.18s-18.18-.08-18.18-.18,8.14-.17,18.18-.17S422.63,223.47,422.63,223.56Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "404.45px 223.565px"
    },
    id: "elkvwo10fq7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.28,189.43l3.28,25.36h42.6V190.23H404.81l-3.75-3.3H380.48A2.22,2.22,0,0,0,378.28,189.43Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "401.211px 200.86px"
    },
    id: "eleycu3pds4dl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.43,200.17c0,.09-4.66.17-10.41.17s-10.42-.08-10.42-.17S396.26,200,402,200,412.43,200.07,412.43,200.17Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "402.015px 200.17px"
    },
    id: "elxg3dfvnaqvc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.43,202.66c0,.1-4.66.17-10.41.17s-10.42-.07-10.42-.17,4.66-.17,10.42-.17S412.43,202.56,412.43,202.66Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "402.015px 202.66px"
    },
    id: "elqxcm2c5s79",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.7,228.3c0,.1-5.11.18-11.4.18s-11.4-.08-11.4-.18,5.1-.17,11.4-.17S413.7,228.21,413.7,228.3Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "402.3px 228.305px"
    },
    id: "elhgl0r86ya7",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-81",
    className: "animable",
    style: {
      transformOrigin: "244px 465.69px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.4,465.69c0,.15-98.24.26-219.39.26s-219.41-.11-219.41-.26,98.22-.26,219.41-.26S463.4,465.55,463.4,465.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "244px 465.69px"
    },
    id: "elxepd9altm3s",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-81",
    className: "animable animator-active",
    style: {
      transformOrigin: "205.62px 187.474px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.38,261H219.64l-14.85,22L190.3,261H113.94a8.84,8.84,0,0,1-8.84-8.84V100.75a8.84,8.84,0,0,1,8.84-8.85H297.38a8.84,8.84,0,0,1,8.84,8.85V252.2A8.84,8.84,0,0,1,297.38,261Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "205.66px 187.45px"
    },
    id: "elmo7625ekc9a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.38,261l.48,0a8.88,8.88,0,0,0,1.43-.21,8.78,8.78,0,0,0,6.61-6.54,10.19,10.19,0,0,0,.21-1.15c0-.4.05-.81,0-1.23,0-.84,0-1.72,0-2.63q0-5.48,0-12.59c0-19-.05-46.38-.08-80.25,0-16.95,0-35.5,0-55.42a8.66,8.66,0,0,0-6-8.44,10.31,10.31,0,0,0-3.73-.42H247.9l-70.29,0H114.23c-.41,0-.79,0-1.18,0a9.27,9.27,0,0,0-1.15.21,8.51,8.51,0,0,0-6.29,6.31,17.89,17.89,0,0,0-.25,4.29v64c0,22.15,0,43.61,0,64.18v19a20.33,20.33,0,0,0,.16,3.68,8.61,8.61,0,0,0,4,5.71,8.36,8.36,0,0,0,3.35,1.15c1.17.12,2.42.05,3.62.07H137.9l52.4,0h.11l.06.09,14.47,22h-.3l14.87-22,.05-.07h.08L277,261l15.2,0,3.9,0,1.33,0-1.33,0-3.9,0-15.2,0-57.31.07.13-.07q-6.9,10.28-14.83,22.05l-.15.23-.15-.23-14.5-22,.16.09-52.4,0H116.52c-1.22,0-2.41.05-3.67-.07A9.1,9.1,0,0,1,105,254a20,20,0,0,1-.18-3.77v-19c0-20.57,0-42,0-64.18V100.83a9.07,9.07,0,0,1,6.94-8.92,10.06,10.06,0,0,1,1.22-.22c.41,0,.83,0,1.23,0H296.31a10.85,10.85,0,0,1,3.87.45,9.18,9.18,0,0,1,3.34,2,9,9,0,0,1,2.21,3.14,9.51,9.51,0,0,1,.71,3.75c0,19.92,0,38.47,0,55.42,0,33.87-.06,61.29-.08,80.25q0,7.11,0,12.59c0,.91,0,1.79,0,2.63,0,.42,0,.84-.05,1.24a8.65,8.65,0,0,1-.21,1.17,8.86,8.86,0,0,1-6.73,6.57,8.15,8.15,0,0,1-1.43.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "205.62px 187.474px"
    },
    id: "ellwx0wsnhazs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.24,185c0,2-1.47,3.18-3.83,3.18h-1.77v2.43h-2v-8.81h3.81C181.77,181.84,183.24,183.06,183.24,185Zm-2.07,0c0-1-.62-1.54-1.87-1.54h-1.66v3.06h1.66C180.55,186.56,181.17,186,181.17,185Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "179.44px 186.205px"
    },
    id: "elyg4m5i74sd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.47,186.79v3.86h-1.84v-.84a2.23,2.23,0,0,1-2.06.94c-1.58,0-2.53-.88-2.53-2.05s.85-2,2.91-2h1.56c0-.84-.5-1.33-1.56-1.33A3.25,3.25,0,0,0,185,186l-.71-1.37a5.22,5.22,0,0,1,2.92-.82C189.28,183.78,190.47,184.74,190.47,186.79Zm-2,1.72v-.69h-1.35c-.92,0-1.21.34-1.21.79s.42.82,1.11.82A1.45,1.45,0,0,0,188.51,188.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "187.255px 187.285px"
    },
    id: "elhl44oxrf0pn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.59,190l.65-1.41a4.67,4.67,0,0,0,2.36.65c.9,0,1.24-.23,1.24-.61,0-1.11-4.09,0-4.09-2.68,0-1.28,1.16-2.19,3.14-2.19a5.64,5.64,0,0,1,2.6.59l-.65,1.4a3.88,3.88,0,0,0-2-.5c-.88,0-1.26.27-1.26.62,0,1.16,4.09,0,4.09,2.71,0,1.26-1.17,2.15-3.2,2.15A5.88,5.88,0,0,1,191.59,190Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "194.63px 187.245px"
    },
    id: "ele82vp09h36q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.27,190l.65-1.41a4.67,4.67,0,0,0,2.35.65c.91,0,1.25-.23,1.25-.61,0-1.11-4.09,0-4.09-2.68,0-1.28,1.16-2.19,3.13-2.19a5.65,5.65,0,0,1,2.61.59l-.66,1.4a3.83,3.83,0,0,0-1.95-.5c-.88,0-1.25.27-1.25.62,0,1.16,4.08,0,4.08,2.71,0,1.26-1.17,2.15-3.19,2.15A5.85,5.85,0,0,1,198.27,190Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "201.33px 187.245px"
    },
    id: "elnsydl05b8b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.34,183.88l-2.45,6.77H212l-1.52-4.2-1.57,4.2H207l-2.44-6.77h1.85l1.6,4.58,1.66-4.58h1.66l1.61,4.58,1.65-4.58Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "210.45px 187.265px"
    },
    id: "elcjtflotawt8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.57,187.27a3.72,3.72,0,1,1,3.72,3.48A3.48,3.48,0,0,1,216.57,187.27Zm5.45,0a1.74,1.74,0,1,0-1.73,1.87A1.72,1.72,0,0,0,222,187.27Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "220.282px 187.034px"
    },
    id: "eldu2mog137nc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.51,183.78v1.81l-.44,0a1.66,1.66,0,0,0-1.8,1.88v3.2h-2v-6.77h1.88v.89A2.72,2.72,0,0,1,229.51,183.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "227.39px 187.22px"
    },
    id: "elvs77eeear8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.51,181.32v9.33h-1.87v-.78a2.61,2.61,0,0,1-2.11.88,3.49,3.49,0,0,1,0-7,2.6,2.6,0,0,1,2,.82v-3.28Zm-1.92,6a1.74,1.74,0,1,0-1.73,1.87A1.72,1.72,0,0,0,235.59,187.27Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "233.77px 186.022px"
    },
    id: "elnj4x29eq03",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.13,
    y: 205.84,
    width: 23.7,
    height: 32.79,
    rx: 5.48,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "149.98px 222.235px"
    },
    id: "elp5yf20ccp4m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.7,
    y: 205.84,
    width: 23.06,
    height: 32.79,
    rx: 5.48,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "206.23px 222.235px"
    },
    id: "eldhpprwoe88r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.98,
    y: 205.84,
    width: 23.06,
    height: 32.79,
    rx: 5.48,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "178.51px 222.235px"
    },
    id: "elpda3h75jm6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.29,
    y: 205.84,
    width: 23.71,
    height: 32.79,
    rx: 5.48,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "234.145px 222.235px"
    },
    id: "elf2poy1qzfo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.48,
    y: 205.84,
    width: 23.71,
    height: 32.79,
    rx: 5.48,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "261.335px 222.235px"
    },
    id: "elaaz4tm70ln9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,221.37l2.53,1.37-1.14,1.91-2.55-1.52,0,2.82h-2.18l0-2.84-2.56,1.54-1.12-1.91,2.54-1.37-2.54-1.4,1.12-1.91,2.56,1.54,0-2.84h2.18l0,2.84,2.55-1.54,1.14,1.91Z",
    style: {
      fill: "rgb(68, 8, 78)",
      transformOrigin: "150.755px 221.355px"
    },
    id: "el2mjcj9g0di2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.66,221.22l2.54,1.37-1.14,1.91L179.5,223l.05,2.82h-2.19l0-2.84-2.56,1.54-1.11-1.91,2.53-1.37-2.53-1.4,1.11-1.91,2.56,1.54,0-2.84h2.19l-.05,2.84,2.56-1.54,1.14,1.91Z",
    style: {
      fill: "rgb(68, 8, 78)",
      transformOrigin: "178.445px 221.225px"
    },
    id: "el4rbiwn74egj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,221.22l2.54,1.37-1.14,1.91L207.79,223l.05,2.82h-2.19l0-2.84-2.56,1.54L202,222.59l2.53-1.37-2.53-1.4,1.11-1.91,2.56,1.54,0-2.84h2.19l-.05,2.84,2.56-1.54,1.14,1.91Z",
    style: {
      fill: "rgb(68, 8, 78)",
      transformOrigin: "206.77px 221.215px"
    },
    id: "elbp8feclxte",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.36,221.22l2.53,1.37-1.14,1.91L235.19,223l.05,2.82h-2.19l0-2.84-2.56,1.54-1.12-1.91,2.54-1.37-2.54-1.4,1.12-1.91,2.56,1.54,0-2.84h2.19l-.05,2.84,2.56-1.54,1.14,1.91Z",
    style: {
      fill: "rgb(68, 8, 78)",
      transformOrigin: "234.13px 221.225px"
    },
    id: "elme4mpz1ramc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.11,238.84H143.85a5.73,5.73,0,0,1-5.72-5.72V211.36a5.73,5.73,0,0,1,5.72-5.72h12.26a5.72,5.72,0,0,1,5.72,5.72v21.76A5.73,5.73,0,0,1,156.11,238.84ZM143.85,206a5.32,5.32,0,0,0-5.31,5.32v21.76a5.31,5.31,0,0,0,5.31,5.31h12.26a5.32,5.32,0,0,0,5.32-5.31V211.36a5.33,5.33,0,0,0-5.32-5.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "149.98px 222.24px"
    },
    id: "elpdc0a9143b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.59,238.84H172.32a5.73,5.73,0,0,1-5.72-5.72V211.36a5.73,5.73,0,0,1,5.72-5.72h12.27a5.72,5.72,0,0,1,5.71,5.72v21.76A5.72,5.72,0,0,1,184.59,238.84ZM172.32,206a5.32,5.32,0,0,0-5.31,5.32v21.76a5.31,5.31,0,0,0,5.31,5.31h12.27a5.31,5.31,0,0,0,5.31-5.31V211.36a5.32,5.32,0,0,0-5.31-5.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "178.45px 222.24px"
    },
    id: "elplnl118zwvk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.28,238.84H200a5.73,5.73,0,0,1-5.72-5.72V211.36a5.73,5.73,0,0,1,5.72-5.72h12.27a5.72,5.72,0,0,1,5.71,5.72v21.76A5.72,5.72,0,0,1,212.28,238.84ZM200,206a5.32,5.32,0,0,0-5.31,5.32v21.76a5.31,5.31,0,0,0,5.31,5.31h12.27a5.31,5.31,0,0,0,5.31-5.31V211.36a5.32,5.32,0,0,0-5.31-5.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "206.13px 222.24px"
    },
    id: "el78tqwosoy9o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.28,238.84H228a5.73,5.73,0,0,1-5.72-5.72V211.36a5.72,5.72,0,0,1,5.72-5.72h12.26a5.73,5.73,0,0,1,5.72,5.72v21.76A5.73,5.73,0,0,1,240.28,238.84ZM228,206a5.33,5.33,0,0,0-5.32,5.32v21.76a5.32,5.32,0,0,0,5.32,5.31h12.26a5.31,5.31,0,0,0,5.31-5.31V211.36a5.32,5.32,0,0,0-5.31-5.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "234.13px 222.24px"
    },
    id: "elw62ac8z43ll",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.47,238.84H255.21a5.73,5.73,0,0,1-5.72-5.72V211.36a5.72,5.72,0,0,1,5.72-5.72h12.26a5.73,5.73,0,0,1,5.72,5.72v21.76A5.73,5.73,0,0,1,267.47,238.84ZM255.21,206a5.33,5.33,0,0,0-5.32,5.32v21.76a5.32,5.32,0,0,0,5.32,5.31h12.26a5.31,5.31,0,0,0,5.31-5.31V211.36a5.32,5.32,0,0,0-5.31-5.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "261.34px 222.24px"
    },
    id: "elxi367tul3l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.91,230.13a40.81,40.81,0,0,1-6.57.26,40.81,40.81,0,0,1-6.57-.26,42.24,42.24,0,0,1,6.57-.26A42.24,42.24,0,0,1,267.91,230.13Z",
    style: {
      fill: "rgb(68, 8, 78)",
      transformOrigin: "261.34px 230.132px"
    },
    id: "eltyyuunz1c7a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.74,
    cy: 145.35,
    r: 26.49,
    style: {
      fill: "rgb(68, 8, 78)",
      transformOrigin: "206.74px 145.35px"
    },
    id: "el909iot07d8d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.08,140.53h-.44v-2.47a5.17,5.17,0,1,1,10.33,0v2h-.44v-2a4.73,4.73,0,1,0-9.45,0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "206.805px 136.596px"
    },
    id: "ely8vzelmv6no",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.31,157.8H200.18a2.17,2.17,0,0,1-2.18-2.18V142.49a2.18,2.18,0,0,1,2.18-2.18h13.13a2.19,2.19,0,0,1,2.18,2.18v13.13A2.18,2.18,0,0,1,213.31,157.8Zm-13.13-17.05a1.74,1.74,0,0,0-1.74,1.74v13.13a1.74,1.74,0,0,0,1.74,1.74h13.13a1.74,1.74,0,0,0,1.74-1.74V142.49a1.74,1.74,0,0,0-1.74-1.74Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "206.745px 149.055px"
    },
    id: "el6i412ebmi28",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.81,149.49a2.07,2.07,0,1,1,2.06-2.06A2.07,2.07,0,0,1,206.81,149.49Zm0-3.68a1.62,1.62,0,1,0,1.62,1.62A1.61,1.61,0,0,0,206.81,145.81Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "206.8px 147.42px"
    },
    id: "eliwyb40bbjz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.52,
    y: 149.17,
    width: 0.44,
    height: 3.72,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "206.74px 151.03px"
    },
    id: "el2zyv7l39w2m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpjc8jf4w89e"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 288.45,
    cy: 106.93,
    r: 8.18,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "288.45px 106.93px",
      transform: "rotate(-77.59deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M285.81,109.83a.25.25,0,0,1-.18-.08.24.24,0,0,1,0-.35l5.3-5.3a.24.24,0,0,1,.35,0,.25.25,0,0,1,0,.36l-5.3,5.29A.25.25,0,0,1,285.81,109.83Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "288.455px 106.927px"
    },
    id: "elqoipuxzso3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.1,109.83a.25.25,0,0,1-.17-.08l-5.3-5.29a.25.25,0,0,1,0-.36.24.24,0,0,1,.35,0l5.3,5.3a.24.24,0,0,1,0,.35A.25.25,0,0,1,291.1,109.83Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "288.455px 106.927px"
    },
    id: "elg3iz33les4r",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-81",
    className: "animable",
    style: {
      transformOrigin: "87.9476px 382.072px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.06,415.55s-26.42-30.41-36.39-60.82-5.24-26.92-5.24-26.92,13.46,29.54,23.68,43.81,28.42,35.2,28.42,35.2Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "61.9194px 371.619px"
    },
    id: "elkzlqhfoeis",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.32,332.54a1.54,1.54,0,0,0-2.86,1c1.61,10.69,5.09,35.75,5,52-.17,21.12,0,29.28,0,29.28h11s-2-43.66-4.44-57C90.24,348.51,86.54,338.15,83.32,332.54Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "88.4507px 373.291px"
    },
    id: "el0ekkahn6tkjg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.32,411.26a116.45,116.45,0,0,0,9.05-32.83c.9-7.77-.71-18.28-3.11-32.3a86.23,86.23,0,0,1-1.39-15.54,2.62,2.62,0,0,1,4.92-1.23c1.33,2.37,5.17,10.46,6.15,15.53,2.66,13.84,5.67,20.76,3.37,33.9s-10.83,33.36-10.83,33.36Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "99.2239px 370.072px"
    },
    id: "eleuyzta1pssa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.22,412.15s29-62.34,31-71.59,8.85-30.56,9.65-29.35,2,12.46-3.21,25.33-27.55,77.51-27.55,77.51H99.22",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "119.903px 362.605px"
    },
    id: "eld1gphw5t30c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.14,409.36a5.17,5.17,0,0,1-.81-.56c-.52-.39-1.3-.94-2.25-1.71-1.93-1.52-4.64-3.83-7.8-6.88a131,131,0,0,1-21-27,177.19,177.19,0,0,1-14.37-31.12c-1.46-4.14-2.52-7.53-3.21-9.88-.36-1.18-.6-2.1-.77-2.72a5.84,5.84,0,0,1-.23-1,5.72,5.72,0,0,1,.35.92c.22.67.51,1.57.88,2.69.76,2.33,1.89,5.69,3.39,9.81a189.06,189.06,0,0,0,14.49,30.95,137,137,0,0,0,20.82,27c3.11,3.09,5.76,5.44,7.64,7,.93.8,1.69,1.38,2.17,1.8A6.1,6.1,0,0,1,86.14,409.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "60.92px 368.925px"
    },
    id: "el8n95edmqgkj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.32,379.45a8.77,8.77,0,0,1-.26-1.83c-.14-1.29-.32-3-.54-5-.46-4.22-1.18-10-2.2-16.43s-2.17-12.14-3.06-16.28c-.43-2-.78-3.65-1.06-4.92a10.16,10.16,0,0,1-.32-1.82,10.72,10.72,0,0,1,.56,1.76c.32,1.15.75,2.81,1.25,4.88,1,4.13,2.21,9.88,3.24,16.29s1.68,12.24,2,16.48c.17,2.11.29,3.83.34,5A11.26,11.26,0,0,1,89.32,379.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "85.609px 356.31px"
    },
    id: "elhepzvlq0kn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.11,328.87a3.88,3.88,0,0,1,.34.79l.87,2.32c.39,1,.83,2.24,1.25,3.71s1,3.11,1.41,5l.72,2.93c.24,1,.41,2.1.63,3.21.48,2.21.77,4.61,1.12,7.13a116.3,116.3,0,0,1,.7,16.52,116.19,116.19,0,0,1-1.88,16.44c-.53,2.48-1,4.86-1.62,7-.31,1.09-.56,2.16-.87,3.16L97.85,400c-.55,1.84-1.23,3.45-1.76,4.88s-1,2.64-1.51,3.61l-1,2.25a3.94,3.94,0,0,1-.4.76,4.55,4.55,0,0,1,.28-.81c.24-.58.55-1.34.93-2.29s.91-2.2,1.4-3.65,1.15-3,1.68-4.89c.28-.91.57-1.87.88-2.87s.54-2.06.83-3.15c.6-2.17,1-4.53,1.56-7a121.7,121.7,0,0,0,1.82-16.35,121.6,121.6,0,0,0-.64-16.43c-.34-2.51-.61-4.9-1.06-7.11-.21-1.1-.37-2.18-.6-3.2s-.46-2-.68-2.93c-.39-1.87-.92-3.52-1.31-5s-.8-2.72-1.15-3.74l-.75-2.35A4.54,4.54,0,0,1,96.11,328.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "98.1891px 370.185px"
    },
    id: "el0pfndoaunb3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.56,312.46a1.19,1.19,0,0,1,0,.28c0,.22-.08.48-.13.81-.13.71-.29,1.76-.57,3.1-.56,2.68-1.5,6.54-3,11.22s-3.42,10.18-5.77,16.21-5.06,12.61-7.64,19.61-4.63,13.81-6.52,20-3.66,11.75-5.38,16.34A103.69,103.69,0,0,1,106,410.7c-.59,1.23-1.13,2.15-1.47,2.79l-.41.71c-.09.16-.14.24-.15.23a.84.84,0,0,1,.1-.26l.35-.74c.31-.65.81-1.59,1.37-2.84,1.16-2.47,2.74-6.1,4.38-10.71s3.4-10.15,5.24-16.35,3.87-13,6.49-20,5.32-13.59,7.69-19.61,4.39-11.47,5.89-16.13,2.49-8.48,3.12-11.14c.32-1.33.52-2.37.69-3.08.07-.32.14-.58.19-.79A.91.91,0,0,1,139.56,312.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "121.769px 363.445px"
    },
    id: "elgdm1d99ddrp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.11,298.69A2.49,2.49,0,0,0,46,301.23a71.15,71.15,0,0,0,3.64,9.38c4,8.47,15.7,38.88,21.19,55.58S84,414.05,84,414.05l11.71-1.9S85,361,74.57,342.51C66.16,327.69,57.74,306.27,50.11,298.69Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "70.7961px 356.017px"
    },
    id: "elfwchd55cw7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,376.64a6.55,6.55,0,0,1,.61,1.4c.34.92.82,2.26,1.35,3.93,1.08,3.34,2.4,8,3.72,13.19s2.44,9.91,3.21,13.33c.35,1.61.64,3,.88,4.05a7.73,7.73,0,0,1,.24,1.51,7.5,7.5,0,0,1-.48-1.45c-.28-1.07-.64-2.41-1.07-4-.9-3.52-2.07-8.15-3.38-13.27s-2.57-9.86-3.54-13.22c-.46-1.59-.85-2.92-1.16-4A7.63,7.63,0,0,1,74,376.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "79.005px 395.345px"
    },
    id: "eljiqsz8vm57o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.92,413.1a1.24,1.24,0,0,1-.06-.31c0-.25-.08-.55-.14-.92-.12-.81-.23-2-.48-3.55-.43-3.08-1.19-7.51-2.45-12.92a186.45,186.45,0,0,0-5.48-18.7c-2.41-6.94-5.42-14.44-8.83-22.2-6.89-15.49-13.77-29.24-18.3-39.4-2.28-5.08-4-9.21-5.22-12.1-.59-1.44-1-2.57-1.31-3.33-.14-.35-.24-.64-.33-.87a1.13,1.13,0,0,1-.09-.31,1.35,1.35,0,0,1,.15.28l.38.85c.35.8.82,1.9,1.43,3.29,1.23,2.85,3.06,7,5.39,12C59.2,325,66.15,338.73,73.05,354.25c3.41,7.77,6.42,15.29,8.8,22.26a177,177,0,0,1,5.37,18.8,130.21,130.21,0,0,1,2.26,13c.21,1.54.28,2.75.37,3.56l.07.93A1.3,1.3,0,0,1,89.92,413.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "68.5793px 355.795px"
    },
    id: "elcetgp08ym0o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.75,412.15a12.85,12.85,0,0,1-.4-2c-.23-1.37-.54-3.19-.91-5.38-.8-4.54-2-10.79-3.81-17.59S86.9,374.35,85.38,370c-.74-2.1-1.36-3.83-1.83-5.14a12.41,12.41,0,0,1-.62-1.91,12,12,0,0,1,.85,1.82c.5,1.19,1.21,2.92,2,5.08a170,170,0,0,1,5.44,17.21,178.4,178.4,0,0,1,3.65,17.67c.33,2.28.58,4.13.71,5.42A13.34,13.34,0,0,1,95.75,412.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "89.34px 387.55px"
    },
    id: "ell6idce70ybb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.08,
    y: 410.47,
    width: 45.71,
    height: 55.69,
    style: {
      fill: "rgb(68, 8, 78)",
      transformOrigin: "96.935px 438.315px"
    },
    id: "elks5994dcm9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elb26rj9ejnx"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "96.935px 438.315px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.08,
    y: 410.47,
    width: 45.71,
    height: 55.69,
    id: "el5641rtv1cgd",
    className: "animable",
    style: {
      transformOrigin: "96.935px 438.315px"
    }
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 64.65,
    y: 410.47,
    width: 40.55,
    height: 55.69,
    style: {
      fill: "rgb(68, 8, 78)",
      transformOrigin: "84.925px 438.315px"
    },
    id: "eld1m2u0fy03k",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-81",
    className: "animable",
    style: {
      transformOrigin: "300.568px 310.023px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "386.91 286.57 362.88 283.09 314.81 290.2 301.32 294.97 303.71 324.47 349.93 332.98 381.11 323.74 392.9 306.39 386.91 286.57",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "347.11px 308.035px"
    },
    id: "el3rln0f7xch8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.06,289.39l-20.12-4.74s-14.21,44-49.3,42.07c-28.6-1.55-28.93-33.47-28.93-33.47l-20.61,6.6s-7.89,52.87.84,90.33c2,8.75,4.77,20.54,4.77,20.54l-2.79,54.73,152.44.24-36.3-176.3Z",
    style: {
      fill: "rgb(68, 8, 78)",
      transformOrigin: "359.095px 375.17px"
    },
    id: "elxae3brekxxe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elthcwf6q2aqd"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "389.555px 451.465px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.3,454.83c7.42-.19,14.26.44,21.68.26,8.9-.22,17.87-.44,26.66,1,6.58,1.09,13,3.09,19.58,4.13,9,1.42,18.59.92,26.59-3.41l-1.29-7.47L405.14,442Z",
    id: "elwmmn56r5n6b",
    className: "animable",
    style: {
      transformOrigin: "389.555px 451.465px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M265.89,312.17c7-9,18.56-12.75,18.56-12.75l7.8,67.89-14.77,98.86-48.38-.23S255.78,325.22,265.89,312.17Z",
    style: {
      fill: "rgb(68, 8, 78)",
      transformOrigin: "260.675px 382.795px"
    },
    id: "el2e670bhflrk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.71,288.89s32.56,2.61,44.24,56c5.28,24.13,12,52.4,13.89,71.41,1.39,13.78-6.1,35.36-19.84,37.13l-17.28,2.32a28.55,28.55,0,0,1-10.18-.37c-10.91-2.51-12-10-14-18l-5-15.92c-2.76-15.14,11.35-18,19.14-17.79l-5.81-69.11Z",
    style: {
      fill: "rgb(68, 8, 78)",
      transformOrigin: "424.596px 372.466px"
    },
    id: "elvhhit1nzyee",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.42,337.17a3.54,3.54,0,0,0-.15.74c-.08.54-.19,1.26-.33,2.15-.06.47-.14,1-.22,1.56s-.12,1.19-.19,1.86c-.14,1.33-.3,2.85-.37,4.54a114.81,114.81,0,0,0-.08,11.87,144.9,144.9,0,0,0,1.44,14.45c.75,5.11,1.69,9.93,2.65,14.29s1.89,8.27,2.71,11.55,1.51,5.91,2,7.73c.24.87.43,1.57.58,2.09a3.53,3.53,0,0,0,.24.72,3.72,3.72,0,0,0-.14-.74c-.12-.54-.28-1.24-.48-2.12-.45-1.89-1.08-4.53-1.86-7.77s-1.68-7.2-2.59-11.56-1.86-9.17-2.6-14.26-1.26-10-1.48-14.41-.23-8.46,0-11.82c.05-1.69.18-3.2.29-4.54q.07-1,.15-1.86c.06-.56.12-1.08.17-1.56.1-.89.18-1.61.23-2.16A3.84,3.84,0,0,0,280.42,337.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "283.832px 373.945px"
    },
    id: "elkd7rupmlp98",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.23,422.37A5.86,5.86,0,0,0,436,421a21.82,21.82,0,0,0-1.26-3.51,23.93,23.93,0,0,0-19.11-13.91,21,21,0,0,0-3.73-.12,6.1,6.1,0,0,0-1.36.17,44.65,44.65,0,0,1,5,.31,24.69,24.69,0,0,1,18.83,13.7A48.49,48.49,0,0,1,436.23,422.37Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "423.385px 412.898px"
    },
    id: "elrt9ewbzc6w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.71,395.79a2.51,2.51,0,0,0-.79-.07,16.6,16.6,0,0,0-2.15.1,24.67,24.67,0,0,0-6.87,1.72,25.25,25.25,0,0,0-6.1,3.61,17.37,17.37,0,0,0-1.59,1.44c-.35.37-.53.58-.51.61s.88-.7,2.33-1.76a28.71,28.71,0,0,1,12.79-5.26C427.59,395.92,428.71,395.88,428.71,395.79Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "419.704px 399.457px"
    },
    id: "els7keu0z1wea",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395,326.72a7.39,7.39,0,0,0,.08-1.43c0-.92.06-2.24.17-3.87A62.14,62.14,0,0,1,402.11,297c.75-1.45,1.4-2.61,1.87-3.39a7.38,7.38,0,0,0,.67-1.26,7.54,7.54,0,0,0-.85,1.15c-.52.76-1.22,1.89-2,3.33a56.32,56.32,0,0,0-6.9,24.58c-.06,1.64-.06,3,0,3.89A6.9,6.9,0,0,0,395,326.72Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "399.752px 309.535px"
    },
    id: "elw190st3dthi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.64,375.15a2.17,2.17,0,0,0,.14.56c.12.36.27.91.54,1.57a32.58,32.58,0,0,0,2.71,5.49,35.29,35.29,0,0,0,34.57,16.6,33.69,33.69,0,0,0,6-1.31c.69-.21,1.21-.44,1.56-.57a3,3,0,0,0,.53-.23c0-.05-.77.21-2.15.6a35.71,35.71,0,0,1-6,1.14,35.46,35.46,0,0,1-34.21-16.42,37.91,37.91,0,0,1-2.84-5.37C333,375.89,332.68,375.13,332.64,375.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "355.665px 387.401px"
    },
    id: "elunex4zf7z2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.26,450.2c.05-.05.56.68,1.78,1.68a16.35,16.35,0,0,0,6,2.84,31.53,31.53,0,0,0,9.8.87c3.72-.27,7.83-.71,12.09-1.34a62,62,0,0,0,11.8-2.72,15,15,0,0,0,4.33-2.89,22.49,22.49,0,0,0,3-3.45,32.61,32.61,0,0,0,3.33-5.77c.31-.73.55-1.29.7-1.68a2.28,2.28,0,0,1,.26-.58,4.11,4.11,0,0,1-.16.61c-.12.41-.33,1-.62,1.73a29.22,29.22,0,0,1-3.21,5.91,22.34,22.34,0,0,1-3,3.54,15.12,15.12,0,0,1-4.44,3,58.81,58.81,0,0,1-11.9,2.79c-4.29.64-8.39,1.06-12.14,1.31a31.5,31.5,0,0,1-9.93-1,16,16,0,0,1-6-3,9.58,9.58,0,0,1-1.27-1.33A2.62,2.62,0,0,1,401.26,450.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "427.805px 446.632px"
    },
    id: "el9kil16v6umh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.89,343.72c.13,0,3.57,13.29,7.66,29.77s7.3,29.86,7.16,29.9-3.57-13.3-7.66-29.78S395.75,343.75,395.89,343.72Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "403.3px 373.555px"
    },
    id: "elpq5siltrlsk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.74,419a4.08,4.08,0,0,1-.17-1.1,19.59,19.59,0,0,1-.07-3,8.89,8.89,0,0,1,1.47-4.27,12.7,12.7,0,0,1,1.67-2.1,11.77,11.77,0,0,1,2.31-1.72,29.28,29.28,0,0,1,9.48-3.06,26.64,26.64,0,0,1,3-.26,3.78,3.78,0,0,1,1.11,0c0,.08-1.57.14-4.06.59a31.58,31.58,0,0,0-9.28,3.14,11.6,11.6,0,0,0-2.22,1.64,12.56,12.56,0,0,0-1.62,2,8.61,8.61,0,0,0-1.5,4,25.56,25.56,0,0,0-.09,3A4.93,4.93,0,0,1,391.74,419Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "401.006px 411.225px"
    },
    id: "eluqpymjvx6la",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmc1dnwqh7k"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "278.806px 358.5px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.92,382c-8.31-14.07-8.49-32.35-1.24-47a131.76,131.76,0,0,0,1.48,46.94",
    id: "el9q80j9ntkqr",
    className: "animable",
    style: {
      transformOrigin: "278.806px 358.5px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M325.89,417.08l.06,0Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "325.92px 417.08px"
    },
    id: "elo5y11z387f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.25,417.25l.13.06Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "326.315px 417.28px"
    },
    id: "elhkh4gu1r4t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,417.11l.3.14Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "326.15px 417.18px"
    },
    id: "elnrw9bpulf5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.76,417l.13.06Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "325.825px 417.03px"
    },
    id: "el2ggw4nxswq7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.17,445.11c2.62-4.94,23.05-18,23.05-18l-5.53-1.28-6.11,2.58a15,15,0,0,1-2.63,5.72c-2.24,3.2-6.05-.11-6.05-.11l2.58-12.37,12.08-7.27s11.36,1.74,13.2,2.62l4.84,4.43c2.13,1.67,8.27,8.24,9.95,8.44S395,418.22,395,418.22h0c7.23,5.73,11,17.1,12.18,25.31,0,0,1.29,4-.11,6.22l-64.73,5.08-13.72,3.79a97.13,97.13,0,0,1-11.27,3.87c-4.56,1-7.63-.51-7.76-3s3.42-2.8,3.42-2.8a69,69,0,0,0,8.82-3.88,15.47,15.47,0,0,0,5-5.46l-4.89.58s-10.4,7.22-14.31,9.34-4.68-1.77-5-3,11.68-12.91,11.68-12.91-11.41,7-13.46,8.8-5.09,2.31-5.74,1.12S292.56,450.05,295.17,445.11Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "350.777px 438.591px"
    },
    id: "el3i302nt4es5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.38,417.31l.11.06Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "326.435px 417.34px"
    },
    id: "el7nfelkb5zi8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.56,417.4Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "326.56px 417.4px"
    },
    id: "elqlu9h81osam",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.49,417.37l.07,0Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "326.525px 417.37px"
    },
    id: "elimtgw9yq54",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.43,446.25a2.81,2.81,0,0,0,.06-.8,4.68,4.68,0,0,0-.06-.94,7.07,7.07,0,0,0-.23-1.23,17.56,17.56,0,0,0-3.31-6.39,37,37,0,0,0-5-5.18,14.37,14.37,0,0,0-2.35-1.82,25.22,25.22,0,0,0,2.12,2.07,47.64,47.64,0,0,1,4.84,5.23,18.81,18.81,0,0,1,3.36,6.18C351.38,445.11,351.33,446.26,351.43,446.25Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "346.018px 438.07px"
    },
    id: "elvkzegcpgu5e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.69,426.74a7.5,7.5,0,0,0,6.45-2.17c-.08-.11-1.33.82-3.12,1.4S318.69,426.6,318.69,426.74Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "321.915px 425.691px"
    },
    id: "ely2t2v1q9f0l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.29,440.28a64.32,64.32,0,0,0,10.22-4.2,31.23,31.23,0,0,0-5.2,1.88A32.61,32.61,0,0,0,315.29,440.28Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "320.4px 438.18px"
    },
    id: "elrvkb1wgstwl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.25,447.2a12,12,0,0,0,2.66-.95,11.76,11.76,0,0,0,2.6-1.11,10.52,10.52,0,0,0-5.26,2.06Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "328.88px 446.17px"
    },
    id: "elsqu8qcn3lm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,441.18a11.32,11.32,0,0,1,2,1.76,11.09,11.09,0,0,1,1.16,2.42c.06,0,.12-.33,0-.85a4.33,4.33,0,0,0-.82-1.86,4.28,4.28,0,0,0-1.57-1.28C317.32,441.15,317,441.13,317,441.18Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "318.615px 443.259px"
    },
    id: "elbgxqlhaan1p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.18,433.63c-.07.12.83.61,1.42,1.64a13,13,0,0,1,.73,2.05A2.43,2.43,0,0,0,314,435C313.33,433.84,312.2,433.5,312.18,433.63Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "313.332px 435.462px"
    },
    id: "eleb8x5v5m7xb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.8,420.13c.06,0,.24-.2.39-.65a3.55,3.55,0,0,0,0-1.8,3.48,3.48,0,0,0-.86-1.58c-.33-.33-.6-.45-.64-.4a9.44,9.44,0,0,1,1,2.1A8.62,8.62,0,0,1,313.8,420.13Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "313.498px 417.91px"
    },
    id: "el1kaixpnpjj6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.6,451.6a9.29,9.29,0,0,1-.08-1.49c0-.48,0-1.06-.07-1.74s-.06-1.45-.16-2.29a51.31,51.31,0,0,0-2.83-13,46.59,46.59,0,0,0-3.06-6.64c-.6-1-1.12-1.89-1.72-2.7-.28-.41-.56-.8-.83-1.18s-.56-.72-.83-1c-2.15-2.65-3.8-4-3.72-4.08a6.83,6.83,0,0,1,1.16.93,14.81,14.81,0,0,1,1.28,1.21c.47.49,1,1,1.57,1.7.27.34.56.68.86,1s.57.77.87,1.18c.62.81,1.16,1.75,1.77,2.71a43.43,43.43,0,0,1,3.14,6.7,47.62,47.62,0,0,1,2.71,13.12c.07.85.06,1.63.08,2.31s0,1.27,0,1.75A7.46,7.46,0,0,1,407.6,451.6Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "401.023px 434.54px"
    },
    id: "el70ga2zmdno7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eldgc56bf07fg"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "425.765px 412.882px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M429.81,405.35a32.52,32.52,0,0,0-19.18-1.75h0a26.53,26.53,0,0,1,25.89,16.74c.46,1.24,1.38,2.71,2.7,2.52s1.68-1.72,1.68-2.95C440.91,413.44,435.78,407.84,429.81,405.35Z",
    id: "eluhem5x22zke",
    className: "animable",
    style: {
      transformOrigin: "425.765px 412.882px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M280,332.59a3.14,3.14,0,0,1-.86-.29c-.55-.21-1.32-.56-2.26-1a47.34,47.34,0,0,1-7-4.29,48,48,0,0,1-6.14-5.4c-.72-.76-1.29-1.4-1.65-1.85s-.56-.72-.53-.75.94.9,2.44,2.34a63.53,63.53,0,0,0,6.19,5.25,62.43,62.43,0,0,0,6.83,4.37C278.9,332,280.06,332.52,280,332.59Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "270.78px 325.8px"
    },
    id: "elhy0gs7ed7d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.47,336.36a1.12,1.12,0,0,1-.25.17l-.77.46c-.67.41-1.69,1-3,1.66a84,84,0,0,1-11.65,4.91,112.15,112.15,0,0,1-18.23,4.38,176.92,176.92,0,0,1-22.88,1.9c-8.15.19-15.91,0-23-.12a153.24,153.24,0,0,1-18.7-1.41,72.56,72.56,0,0,1-12.32-2.86c-1.41-.48-2.5-.88-3.22-1.19l-.82-.35a1.47,1.47,0,0,1-.28-.13l.3.08.84.3c.73.28,1.83.65,3.25,1.1a79.12,79.12,0,0,0,12.3,2.69,161,161,0,0,0,18.66,1.29c7,.13,14.8.27,22.93.08a179.7,179.7,0,0,0,22.82-1.86,114.07,114.07,0,0,0,18.19-4.25,90.52,90.52,0,0,0,11.68-4.74c1.33-.66,2.36-1.19,3-1.57l.79-.41C395.37,336.39,395.46,336.35,395.47,336.36Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "337.91px 343.14px"
    },
    id: "eldl8chwyuiv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.38,372a5.52,5.52,0,0,1-1.24-.26l-3.33-.91c-2.8-.79-6.66-1.92-10.92-3.19s-8.1-2.46-10.88-3.34l-3.28-1.06a6.89,6.89,0,0,1-1.18-.46,5.52,5.52,0,0,1,1.24.26l3.33.91c2.8.79,6.66,1.92,10.92,3.19s8.1,2.45,10.88,3.33l3.28,1.07A6,6,0,0,1,280.38,372Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "264.965px 367.39px"
    },
    id: "el6ezf5vr671c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.29,427.27c0,.13-10-2.73-22.3-6.4s-22.19-6.76-22.15-6.9,10,2.72,22.3,6.4S283.33,427.13,283.29,427.27Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "261.065px 420.62px"
    },
    id: "ely6nrnyoqzw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.82,307.69a6.92,6.92,0,0,1-1.1.87c-.72.53-1.8,1.27-3.15,2.15A107.32,107.32,0,0,1,401,321.8c-1.52.53-2.76.93-3.63,1.18a6.74,6.74,0,0,1-1.36.34,7.73,7.73,0,0,1,1.3-.53l3.57-1.33c3-1.15,7.11-2.85,11.51-5s8.26-4.37,11-6.05l3.24-2A7.09,7.09,0,0,1,427.82,307.69Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "411.915px 315.505px"
    },
    id: "el53ztpxltkgg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.74,364.51a12.37,12.37,0,0,1-1.62.77c-1.05.47-2.61,1.09-4.55,1.8A105.67,105.67,0,0,1,410,373.36c-2.07.09-3.74.11-4.9.07a13.43,13.43,0,0,1-1.79-.08,10.76,10.76,0,0,1,1.79-.12c1.15,0,2.82-.1,4.88-.24a122.62,122.62,0,0,0,15.95-2.07,124.43,124.43,0,0,0,15.53-4.18c1.95-.67,3.52-1.24,4.6-1.65A10.4,10.4,0,0,1,447.74,364.51Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "425.525px 368.98px"
    },
    id: "el2dhsemzodh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,455.39a2.16,2.16,0,0,1,.05-.56c.06-.41.15-.93.25-1.57s.25-1.52.35-2.5.27-2.08.31-3.32c0-.61.08-1.26.12-1.93s0-1.38,0-2.1c0-1.45-.06-3-.14-4.63a67.9,67.9,0,0,0-1.61-10.48A68.68,68.68,0,0,0,415,418.23c-.68-1.48-1.29-2.91-2-4.18-.34-.64-.65-1.27-1-1.86l-1-1.66c-.61-1.08-1.27-2-1.8-2.81s-1-1.51-1.45-2.06l-.94-1.29a2.08,2.08,0,0,1-.3-.47,3,3,0,0,1,.38.4l1,1.24a24,24,0,0,1,1.53,2c.56.81,1.24,1.71,1.87,2.78l1,1.66c.35.58.67,1.22,1,1.86.72,1.27,1.36,2.7,2,4.19a60.38,60.38,0,0,1,5,20.71c.06,1.64.15,3.2.09,4.66,0,.73,0,1.44-.06,2.12s-.1,1.32-.15,1.94c-.07,1.25-.27,2.35-.4,3.33s-.28,1.82-.43,2.49-.26,1.15-.35,1.57A2.49,2.49,0,0,1,419,455.39Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "413.455px 429.645px"
    },
    id: "el2g5xjkumrgp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.58,424.74c-.05,0-.08-.82-.31-2.26a19.43,19.43,0,0,0-2-5.82,24.52,24.52,0,0,0-5.65-7.12,29.34,29.34,0,0,0-9.61-5.62A37.45,37.45,0,0,0,429,402a69.78,69.78,0,0,0-9.18.35c-2.61.24-4.72.51-6.18.67l-1.68.18a2.19,2.19,0,0,1-.59,0,2.26,2.26,0,0,1,.57-.13l1.67-.28c1.45-.23,3.56-.54,6.17-.84a67.15,67.15,0,0,1,9.24-.46,37.53,37.53,0,0,1,11.16,1.93,29.58,29.58,0,0,1,9.76,5.76,24.31,24.31,0,0,1,5.66,7.31,18.39,18.39,0,0,1,1.83,6,12.49,12.49,0,0,1,.12,1.7A2.46,2.46,0,0,1,457.58,424.74Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "434.477px 413.109px"
    },
    id: "elxssy1hz3ei",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,395.79a2.35,2.35,0,0,1-.57.1l-1.63.17-6,.5c-5.07.39-12.08.87-19.82,1.27s-14.77.65-19.86.71c-2.54,0-4.6,0-6,0l-1.63,0a2.09,2.09,0,0,1-.57-.06,2.49,2.49,0,0,1,.57-.05l1.63,0,6-.15c5.07-.15,12.09-.45,19.83-.86l19.82-1.12,6-.34,1.64-.07A2.28,2.28,0,0,1,350,395.79Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "321.96px 397.166px"
    },
    id: "el5uxs6kral6v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7spomc010j9"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "357.88px 396.046px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.81,397.87c6.3,1.85,15,2.3,21.17,0-4.8,6.83-14.07,9.3-22.12,7.08s-15.46-10.27-16.08-18.6C342.68,391.6,349.51,396,355.81,397.87Z",
    id: "elakrkmvkdcw",
    className: "animable",
    style: {
      transformOrigin: "357.88px 396.046px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M406.9,391.28a3.15,3.15,0,0,1-.51.14l-1.45.31c-1.27.26-3.1.6-5.38,1-4.55.8-10.86,1.78-17.85,2.64s-13.36,1.42-18,1.74c-2.3.16-4.17.27-5.46.32l-1.48.05a1.61,1.61,0,0,1-.52,0,2.68,2.68,0,0,1,.51-.08l1.48-.15,5.44-.49c4.6-.41,10.94-1,17.94-1.89s13.29-1.78,17.85-2.48l5.4-.84,1.48-.21A1.58,1.58,0,0,1,406.9,391.28Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "381.575px 394.389px"
    },
    id: "eljmc6xc9k69o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljsdobsn0rlc"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "403.161px 375.544px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.42,346.76c-1.58,18.1,3.35,36.06,8.24,53.56a7.44,7.44,0,0,0,1.34,3,2.6,2.6,0,0,0,3,.83c1.53-.78,1.32-3,.89-4.64l-13.59-52",
    id: "el9dxuo38wg68",
    className: "animable",
    style: {
      transformOrigin: "403.161px 375.544px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M143.22,364.79l20.55,100.9h178.4a3.56,3.56,0,0,0,3.56-3.56h0a3.56,3.56,0,0,0-3.56-3.56H306.25L287.2,364.73a3.9,3.9,0,0,0-3.78-3.12l-136.34-1.49A3.89,3.89,0,0,0,143.22,364.79Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "244.435px 412.905px"
    },
    id: "elkk40yphjgig",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.22,364.79a2.4,2.4,0,0,1-.06-.3,3.69,3.69,0,0,1,0-.92,4,4,0,0,1,1.89-2.95,3.87,3.87,0,0,1,1.18-.46,5.86,5.86,0,0,1,1.4-.09l3.21,0,8,.07,51.55.49,35.94.36,20.14.21,10.56.11,5.39.05c.46,0,.89,0,1.38,0a3.92,3.92,0,0,1,1.38.4,4.08,4.08,0,0,1,2,2.05,6.34,6.34,0,0,1,.37,1.37l.28,1.36c.18.9.37,1.81.55,2.72.38,1.83.75,3.67,1.13,5.51l2.28,11.23q2.31,11.35,4.72,23.23c3.22,15.82,6.57,32.27,10,49.23l-.24-.2h35.32a6.64,6.64,0,0,1,1.39.08A3.86,3.86,0,0,1,345.3,460a3.82,3.82,0,0,1-1.32,5.52,3.76,3.76,0,0,1-1.68.45H295.83l-48.3,0-83.76,0h-.15l0-.15c-6.29-31-11.4-56.24-14.94-73.72-1.75-8.74-3.12-15.54-4.05-20.16-.46-2.31-.81-4.07-1-5.26s-.33-1.8-.33-1.8.14.61.39,1.79l1.1,5.24c.95,4.62,2.35,11.42,4.15,20.14l15.1,73.7-.19-.16,83.76,0h94.76a3.42,3.42,0,0,0,1.46-.39,3.33,3.33,0,0,0,1.14-4.81,3.26,3.26,0,0,0-2-1.35,6.72,6.72,0,0,0-1.29-.08H306.05l0-.19c-3.44-17-6.77-33.42-10-49.24q-2.41-11.86-4.71-23.23L289,374.92c-.37-1.85-.74-3.68-1.11-5.51-.19-.91-.37-1.82-.56-2.73l-.27-1.35a5.68,5.68,0,0,0-.35-1.29A3.65,3.65,0,0,0,285,362.2a3.72,3.72,0,0,0-1.23-.36c-.42,0-.9,0-1.34,0l-5.4-.06-10.56-.12-20.13-.24L210.4,361l-51.55-.63-8-.11-3.21-.05a6.2,6.2,0,0,0-1.38.07,4.06,4.06,0,0,0-1.15.45,3.89,3.89,0,0,0-1.89,2.88A4.65,4.65,0,0,0,143.22,364.79Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "244.552px 413.015px"
    },
    id: "elu0l6lhxyrgh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.42,411a5.89,5.89,0,1,1-5.89-5.89A5.89,5.89,0,0,1,225.42,411Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "219.53px 411px"
    },
    id: "el4b4sp8liq8i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.38,365.61s.21,0,.62,0h8.74l25.51.12,84.15.59,12.17.1,3,0a7.3,7.3,0,0,1,1.53.09,4.12,4.12,0,0,1,1.44.58,4.19,4.19,0,0,1,1.81,2.46c.23,1,.39,1.92.59,2.88,1.51,7.6,3,14.93,4.35,21.91,2.76,14,5.25,26.55,7.33,37.12l4.91,25c.56,2.95,1,5.24,1.31,6.81.14.77.25,1.36.33,1.78s.09.6.09.6-.06-.2-.14-.59-.22-1-.38-1.77c-.32-1.57-.79-3.85-1.4-6.79-1.2-5.92-2.92-14.46-5.06-25l-7.44-37.1c-1.39-7-2.86-14.31-4.37-21.91-.2-.94-.38-1.92-.58-2.84a3.75,3.75,0,0,0-1.61-2.17A3.68,3.68,0,0,0,279,367a6.68,6.68,0,0,0-1.43-.08l-3,0-12.17-.09-84.16-.74-25.5-.28-6.94-.1-1.8,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "222.32px 415.63px"
    },
    id: "elp7xzei5tmp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.63,212.37a66.1,66.1,0,0,1-21.08,49.87q-4.73-13.65-9.43-27.3",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "366.383px 237.305px"
    },
    id: "ele1m6enaep5d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.59,158.07c8.09-4.42,17.86-5.06,26.9-3.25s17.46,5.9,25.44,10.52c4.48,2.59,8.94,5.44,12.16,9.48,5.87,7.39,11.68,19.53,12.24,29,.46,7.62-2.46,26.69-5.68,33.61-2.95,6.35-16.78,11.19-23.61,12.76L295.4,177.29A31.74,31.74,0,0,1,310.59,158.07Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "341.389px 202.033px"
    },
    id: "elcsig7y16ii7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.79,167.89l15-2.68c-8.21,19.55-10.44,64.25-15.13,84.93-5.54-8-18.39-32.5-17.7-42.23S282,166.24,299.79,167.89Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "298.362px 207.675px"
    },
    id: "el9b3brzwmzcw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,200.43c-.81-11.42-8.21-20.78-19.3-23.61L317.11,168c-14.94-1.61-24.92,16.77-25.9,31.77-1.09,16.67-1.76,34.25.19,46.69,3.91,25,23.07,28.24,23.07,28.24s0,11.9,0,19.2l11.57,47.91,37.29-51.52,7.72-89.54C371.08,200.31,371,201,371,200.43Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "330.607px 254.856px"
    },
    id: "eletggl7on4s8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.72,218.66a3.21,3.21,0,0,0,3.09,3.24,3.07,3.07,0,0,0,3.31-2.89,3.21,3.21,0,0,0-3.08-3.24A3.07,3.07,0,0,0,298.72,218.66Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "301.92px 218.835px"
    },
    id: "elyt3vud37qwq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,209.56c.4.42,2.83-1.37,6.28-1.36s6,1.75,6.35,1.33c.19-.19-.22-.94-1.32-1.75a8.82,8.82,0,0,0-5.08-1.58,8.52,8.52,0,0,0-5,1.6C295.13,208.62,294.77,209.37,295,209.56Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "301.304px 207.912px"
    },
    id: "eliu2m07rlsn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.8,218.66a3.21,3.21,0,0,0,3.09,3.24A3.06,3.06,0,0,0,335.2,219a3.21,3.21,0,0,0-3.08-3.24A3.07,3.07,0,0,0,328.8,218.66Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "332px 218.83px"
    },
    id: "elt4ueof2i0u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.73,209.56c.4.42,2.84-1.37,6.29-1.36s6,1.75,6.35,1.33c.18-.19-.22-.94-1.32-1.75A8.88,8.88,0,0,0,334,206.2a8.57,8.57,0,0,0-5,1.6C327.9,208.62,327.54,209.37,327.73,209.56Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "334.047px 207.912px"
    },
    id: "eljwkfilq6j4n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,236.66c0-.19-2.13-.57-5.61-1-.88-.09-1.71-.27-1.86-.87a4.45,4.45,0,0,1,.6-2.61q1.25-3.19,2.62-6.71c3.64-9.54,6.27-17.39,5.89-17.53s-3.65,7.47-7.29,17q-1.32,3.52-2.51,6.74a5.12,5.12,0,0,0-.47,3.46,2.2,2.2,0,0,0,1.45,1.29,5.38,5.38,0,0,0,1.49.21C314.76,236.84,316.93,236.86,317,236.66Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "313.465px 222.369px"
    },
    id: "el06g99nowr605",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.64,265.79S339.5,283,314.48,280.57v-5.88A63,63,0,0,0,347.64,265.79Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "331.06px 273.298px"
    },
    id: "el07kv11wt5xgv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.82,197.09c.34.94,3.78.5,7.83,1s7.32,1.61,7.86.77c.24-.41-.33-1.29-1.65-2.2a13,13,0,0,0-5.82-2,13.23,13.23,0,0,0-6.13.7C329.42,195.91,328.67,196.64,328.82,197.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "336.682px 196.863px"
    },
    id: "elt70inrega9a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.09,199c.6.79,3,0,5.84-.05s5.28.54,5.84-.28c.24-.4-.14-1.18-1.19-1.93a8.48,8.48,0,0,0-9.41.27C296.15,197.81,295.82,198.62,296.09,199Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "301.92px 197.398px"
    },
    id: "elk3xolqu9i0l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,176.92c1.53-3.76,5.66-6,9.71-6.22s8,1.33,11.54,3.36c14.89,8.61,22.55,29.4,37.26,38.31,3.62,2.19,8.33.18,11.41,3.08s5.07,7.54,3.37,11.41a35.08,35.08,0,0,0,5.11-8.63c1.12-3.17,1.26-6.84-.42-9.75-1.27-2.21-3.52-3.89-4.13-6.36-.55-2.18.31-4.45.22-6.69a14.67,14.67,0,0,0-2.29-6.38c-5.77-10.19-13.7-19.41-23.91-25.15a42.37,42.37,0,0,0-21.95-5.67A32.38,32.38,0,0,0,303,166.52c-3.29,3.07-6.75,6.24-5,10.4",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "337.386px 192.542px"
    },
    id: "el26aqc19y2b1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.56,218.55c.26-.72,13.31-5.42,13.48,8.44.17,13.47-13.42,10.82-13.45,10.43S367.56,218.55,367.56,218.55Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "374.301px 227.546px"
    },
    id: "elgfhji7ir5sp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.7,232.28c.06,0,.23.16.63.34a2.38,2.38,0,0,0,1.76,0c1.41-.53,2.59-2.81,2.63-5.23a7.73,7.73,0,0,0-.68-3.36,2.73,2.73,0,0,0-1.79-1.78,1.18,1.18,0,0,0-1.37.65c-.18.38-.09.65-.17.67s-.29-.22-.18-.78a1.5,1.5,0,0,1,.52-.84,1.74,1.74,0,0,1,1.29-.36,3.28,3.28,0,0,1,2.47,2.07,7.84,7.84,0,0,1,.85,3.74c-.06,2.72-1.42,5.27-3.37,5.85a2.5,2.5,0,0,1-2.14-.33C371.72,232.61,371.65,232.31,371.7,232.28Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "374.674px 227.467px"
    },
    id: "el2jk7n5hjno",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.92,211.63a5.34,5.34,0,0,1-.81-.45c-.52-.33-1.32-.77-2.26-1.44a46.09,46.09,0,0,1-7.28-6.62,130.48,130.48,0,0,1-8.89-11.55,105.42,105.42,0,0,0-11.11-13.84,42.17,42.17,0,0,0-7.18-5.67,35.33,35.33,0,0,0-7.74-3.52,38.38,38.38,0,0,0-14.27-1.75,36.93,36.93,0,0,0-9.56,1.87c-1.11.34-1.93.71-2.5.93a5.13,5.13,0,0,1-.88.31,6.48,6.48,0,0,1,.83-.42,21.65,21.65,0,0,1,2.47-1,34.46,34.46,0,0,1,9.61-2.08A38.19,38.19,0,0,1,327.82,168a35.28,35.28,0,0,1,7.89,3.54,43,43,0,0,1,7.29,5.75,103.2,103.2,0,0,1,11.14,14,139.26,139.26,0,0,0,8.76,11.59,50.3,50.3,0,0,0,7.09,6.72c.92.69,1.69,1.16,2.18,1.52A5.49,5.49,0,0,1,372.92,211.63Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "336.68px 188.951px"
    },
    id: "el6fxa1h5zp4i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.23,234.66a2.65,2.65,0,1,1-.63.2",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "373.71px 237.266px"
    },
    id: "el0a77xcxp98hu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.6,234.86a3.65,3.65,0,0,0-1.21,1.81,2.28,2.28,0,0,0,.52,2.11,2.36,2.36,0,0,0,4.15-1.31,2.29,2.29,0,0,0-.8-2,3.59,3.59,0,0,0-2-.78s.2-.14.63-.15a2.75,2.75,0,0,1,1.68.59,2.7,2.7,0,0,1,1.08,2.43,2.89,2.89,0,0,1-5.13,1.63,2.7,2.7,0,0,1-.52-2.6,2.66,2.66,0,0,1,1-1.45C372.35,234.87,372.59,234.83,372.6,234.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "373.765px 237.401px"
    },
    id: "elocj8mx2kc4p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.53,215.44c.21,3.68.38,7.56-1.32,10.83s-6,5.5-9.18,3.67c-2.61-1.49-3.39-4.84-3.84-7.81-1.27-8.58-1.86-17.25-3.21-25.82Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "360.82px 213.454px"
    },
    id: "el3d46qq4yb2v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.32,170.52c0,.07,1.19-.23,3.34-.3a23.28,23.28,0,0,1,8.92,1.63,29.41,29.41,0,0,1,5.58,2.88,59.27,59.27,0,0,1,5.76,4.4,68.76,68.76,0,0,1,11.28,12.16c1.71,2.4,3.23,4.87,4.87,7.16a34.91,34.91,0,0,0,5.4,6.07,60.39,60.39,0,0,0,11.38,7.61c3.45,1.82,6.33,3.1,8.32,4l2.3,1a4.07,4.07,0,0,0,.83.3,3.86,3.86,0,0,0-.76-.43l-2.25-1.11c-2-1-4.79-2.32-8.18-4.19A62.28,62.28,0,0,1,346.93,204a34.11,34.11,0,0,1-5.26-6c-1.61-2.26-3.12-4.73-4.85-7.16a67.67,67.67,0,0,0-11.44-12.25,59.09,59.09,0,0,0-5.88-4.4,29.35,29.35,0,0,0-5.73-2.85,22.37,22.37,0,0,0-9.12-1.42,15.47,15.47,0,0,0-2.49.35A3.2,3.2,0,0,0,301.32,170.52Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "335.31px 193.659px"
    },
    id: "elbl71hcmjq5c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.9,207.12a6.11,6.11,0,0,0,1.19.8l3.42,2,1.14.65a3.5,3.5,0,0,0,1.48.49,1.42,1.42,0,0,0,.91-.21,1.18,1.18,0,0,0,.5-.89,3,3,0,0,0-.63-1.7l-4-6.34-.54.49a14.12,14.12,0,0,0,9.15,2.73,3.88,3.88,0,0,0,1.23-.21,1.65,1.65,0,0,0,1-.91,1.46,1.46,0,0,0-.23-1.36,5.27,5.27,0,0,0-.76-.84,28.07,28.07,0,0,1-4.59-5.79,48.46,48.46,0,0,1-2.92-6.2,7.06,7.06,0,0,0,.43,1.81,24.45,24.45,0,0,0,2,4.66,26.72,26.72,0,0,0,4.56,6c.5.48,1,1,.81,1.45s-.93.64-1.64.64a13.55,13.55,0,0,1-4.56-.55,13.72,13.72,0,0,1-4.11-2l-1.6-1.18,1.07,1.67,4,6.29a2.56,2.56,0,0,1,.57,1.32c0,.38-.34.6-.77.57a6.68,6.68,0,0,1-2.42-1l-3.52-1.8A6.22,6.22,0,0,0,369.9,207.12Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "377.363px 200.449px"
    },
    id: "elpm62qil4qe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.07,243a4.5,4.5,0,0,0-4.65-3.42,4.67,4.67,0,0,0-3.62,2.57,5.79,5.79,0,0,0-.21,4.51l.08.32a5.13,5.13,0,0,0,5.77,1.23A4.79,4.79,0,0,0,330.07,243Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "325.693px 244.096px"
    },
    id: "elnz3ydfui1n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.16,247.08c0-.52,3.49-.36,6.12-3.22s2.42-6.6,2.91-6.6c.22,0,.64.86.6,2.44a8.68,8.68,0,0,1-2.23,5.51,7.59,7.59,0,0,1-5.12,2.48C320,247.75,319.13,247.32,319.16,247.08Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "323.976px 242.478px"
    },
    id: "eluc2eus4th0e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.72,459a.89.89,0,0,1-.23,0l-.7.07-2.67.22c-2.32.19-5.68.41-9.84.66-8.31.49-19.8,1-32.5,1.21s-24.22.09-32.54-.13c-4.16-.1-7.53-.22-9.85-.32l-2.68-.14-.7,0-.23,0,.23,0h.7l2.68,0,9.86.17c8.32.12,19.82.18,32.52,0s24.18-.66,32.49-1.06l9.85-.49,2.68-.12.69,0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "390.75px 460.135px"
    },
    id: "elkipxrepqbkr",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLeftCard);
export default __webpack_public_path__ + "static/media/login-left-card.624cf9695d1d97a9941c037cc0359981.svg";
export { ForwardRef as ReactComponent };